import { n as yt } from "./property-9daa16cd.mjs";
import { i as fo, E as go, x as vo, d as po } from "./createReactComponent-58f9bea8.mjs";
import { c as Vt, g as yo } from "./_commonjsHelpers-10dfc225.mjs";
var j, L, Fr, Fe = { exports: {} };
j = Fe, L = Fe.exports, Fr = () => (() => {
  var k = { d: (n, t) => {
    for (var e in t)
      k.o(t, e) && !k.o(n, e) && Object.defineProperty(n, e, { enumerable: !0, get: t[e] });
  } };
  k.g = function() {
    if (typeof globalThis == "object")
      return globalThis;
    try {
      return this || new Function("return this")();
    } catch {
      if (typeof window == "object")
        return window;
    }
  }(), k.o = (n, t) => Object.prototype.hasOwnProperty.call(n, t), k.r = (n) => {
    typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(n, "__esModule", { value: !0 });
  };
  var W = {};
  k.d(W, { Editable: () => Ft });
  var q = {};
  k.r(q), k.d(q, { getHost: () => Xt, getNodeIndex: () => bt, isBeginningOfHost: () => kt, isDocumentFragmentWithoutChildren: () => ee, isEndOfHost: () => Yt, isEndOffset: () => Zt, isInlineElement: () => Ur, isLinebreak: () => Ze, isSameNode: () => tn, isStartOffset: () => Jt, isTextEndOfHost: () => Ct, isTextEndOffset: () => te, isVoid: () => Ge, isVoidTextNode: () => Ye, isWhitespaceOnly: () => Je, lastChild: () => wt, lastOffsetWithContent: () => Gt, latestChild: () => qr });
  var D = {};
  function E(n, t) {
    if (!(n instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function A(n) {
    return A = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, A(n);
  }
  function rt(n) {
    var t = function(e, r) {
      if (A(e) != "object" || !e)
        return e;
      var i = e[Symbol.toPrimitive];
      if (i !== void 0) {
        var a = i.call(e, "string");
        if (A(a) != "object")
          return a;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return String(e);
    }(n);
    return A(t) == "symbol" ? t : String(t);
  }
  function He(n, t) {
    for (var e = 0; e < t.length; e++) {
      var r = t[e];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, rt(r.key), r);
    }
  }
  function O(n, t, e) {
    return t && He(n.prototype, t), e && He(n, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
  }
  k.r(D), k.d(D, { adoptElement: () => At, areSameAttributes: () => ue, cleanInternals: () => ln, cloneRangeContents: () => oe, containsString: () => ve, createFragmentFromString: () => X, deleteCharacter: () => ut, expandTo: () => vn, extractContent: () => ie, forceWrap: () => he, getAncestorTags: () => se, getContainedTags: () => dn, getInnerHtmlOfFragment: () => St, getInnerTags: () => ce, getTagNames: () => gn, getTags: () => H, getTagsByName: () => hn, getTagsByNameAndAttributes: () => fn, insertCharacter: () => ge, isAffectedBy: () => Zr, isExactSelection: () => le, isWrappable: () => Et, normalizeTags: () => re, normalizeWhitespace: () => cn, nuke: () => fe, nukeElem: () => de, nukeTag: () => ei, removeFormatting: () => bn, removeFormattingElem: () => mn, selectNodeContents: () => ti, surround: () => kn, tidyHtml: () => at, toggleTag: () => pn, unwrap: () => P, unwrapInternalNodes: () => ae, wrap: () => yn });
  const d = { log: !1, logErrors: !0, editableClass: "js-editable", editableDisabledClass: "js-editable-disabled", pastingAttribute: "data-editable-is-pasting", trimLeadingAndTrailingWhitespaces: !0, boldMarkup: { type: "tag", name: "strong", attribs: {}, trim: !0 }, italicMarkup: { type: "tag", name: "em", attribs: {}, trim: !0 }, underlineMarkup: { type: "tag", name: "u", attribs: {}, trim: !1 }, linkMarkup: { type: "tag", name: "a", attribs: {}, trim: !0 }, pastedHtmlRules: { allowedElements: { a: { href: !0, rel: !0, target: !0 }, strong: {}, em: {}, br: {} }, allowedPlainTextElements: { br: {} }, requiredAttributes: { a: ["href"] }, transformElements: { b: "strong", i: "em" }, splitIntoBlocks: ["h1", "h2", "h3", "h4", "h5", "h6", "p", "blockquote"], blockLevelElements: ["h1", "h2", "h3", "h4", "h5", "h6", "div", "p", "pre", "hr", "blockquote", "article", "figure", "header", "footer", "ul", "ol", "li", "section", "table", "video"], blacklistedElements: ["style", "script"], keepInternalRelativeLinks: !1, replaceQuotes: {} } };
  function Q() {
    if (d.logErrors !== !1) {
      var n = arguments.length === 1 ? arguments[0] : Array.from(arguments);
      if (k.g.console)
        return typeof console.error == "function" ? console.error(n) : void console.log(n);
    }
  }
  var Hr = Object.prototype.toString, Pr = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };
  function Pe(n) {
    return n.replace(/\s+$/, "");
  }
  function Wt(n) {
    return n.replace(/^\s+|\s+$/g, "");
  }
  function Ve(n) {
    return Hr.call(n) === "[object String]";
  }
  var _ = 1, y = 3, qt = 11, it = function(n) {
    function t(e, r) {
      E(this, t), this.current = this.previous = this.nextNode = this.root = e, this.iteratorFunc = this[r || "getNext"];
    }
    return O(t, [{ key: Symbol.iterator, value: function() {
      return this;
    } }, { key: "getNextTextNode", value: function() {
      for (var e; e = this.getNext(); )
        if (e.nodeType === y && e.data !== "")
          return e;
    } }, { key: "getPreviousTextNode", value: function() {
      for (var e; e = this.getPrevious(); )
        if (e.nodeType === y && e.data !== "")
          return e;
    } }, { key: "next", value: function() {
      var e = this.iteratorFunc();
      return e ? { value: e } : { done: !0 };
    } }, { key: "getNext", value: function() {
      var e = this.current = this.nextNode, r = this.nextNode = void 0;
      if (this.current)
        if ((r = e.firstChild) && e.getAttribute("data-editable") !== "remove")
          this.nextNode = r;
        else
          for (; e !== this.root && !(this.nextNode = e.nextSibling); )
            e = e.parentNode;
      return this.current;
    } }, { key: "getPrevious", value: function() {
      var e = this.current = this.previous, r = this.previous = void 0;
      if (this.current)
        if ((r = e.lastChild) && e.getAttribute("data-editable") !== "remove")
          this.previous = r;
        else
          for (; e !== this.root && !(this.previous = e.previousSibling); )
            e = e.parentNode;
      return this.current;
    } }, { key: "replaceCurrent", value: function(e) {
      this.current = e, this.nextNode = void 0, this.previous = void 0;
      for (var r = this.current; r !== this.root && !(this.nextNode = r.nextSibling); )
        r = r.parentNode;
    } }]), t;
  }(), U = function(n, t) {
    return typeof n == "string" ? Array.from(t.querySelectorAll(n)) : n.tagName ? [n] : Array.isArray(n) ? n : Array.from(n);
  }, We = function(n, t) {
    return typeof n == "string" ? t.querySelector(n) : n.tagName ? n : n[0] ? n[0] : n;
  }, qe = function(n) {
    var t = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : window).document.createElement("div");
    return t.innerHTML = n, t.firstElementChild;
  }, Ut = function(n, t) {
    if (n.closest || (n = n.parentNode), n && n.closest)
      return n.closest(t);
  }, F = function() {
    return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window).document.createRange();
  }, Ue = function() {
    return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window).document.getSelection();
  }, zt = function(n, t, e) {
    for (var r, i = [], a = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : window).document.createNodeIterator(n.commonAncestorContainer, NodeFilter.SHOW_ALL, { acceptNode: function(o) {
      return n.intersectsNode(o) && t.includes(o.nodeType) && o !== n.commonAncestorContainer ? typeof e == "function" ? e(o) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    } }, !1); r = a.nextNode(); )
      i.push(r);
    return i;
  }, $t = function(n) {
    n.startContainer.compareDocumentPosition(n.endContainer) === Node.DOCUMENT_POSITION_FOLLOWING && n.setStartBefore(n.endContainer), n.endContainer.compareDocumentPosition(n.startContainer) === Node.DOCUMENT_POSITION_PRECEDING && n.setEndAfter(n.startContainer);
  }, Vr = function(n, t) {
    var e = document.createRange();
    e.selectNodeContents(t);
    var r = n.compareBoundaryPoints(Range.START_TO_START, e), i = n.compareBoundaryPoints(Range.END_TO_END, e);
    return r <= 0 && i >= 0;
  }, ze = function(n) {
    return n && (n.nodeType === Node.TEXT_NODE || n.nodeType === Node.COMMENT_NODE);
  }, $e = function(n, t) {
    return n.splitText(t);
  }, Wr = function(n) {
    var t = n.startContainer, e = n.startOffset, r = n.endContainer, i = n.endOffset;
    if (ze(r) && i > 0 && i < r.length && $e(r, i), ze(t) && e > 0 && e < t.length) {
      var a = $e(t, e);
      n.setStart(a, 0);
    }
  }, Ke = function(n, t) {
    var e = n.cloneRange();
    e.setStart(t, 0), e.setEnd(n.startContainer, n.startOffset);
    var r = n.toString(), i = e.toString().length;
    return { start: i, end: i + r.length, text: r };
  }, Qe = function(n, t) {
    return n.startContainer === t.startContainer && n.startOffset === t.startOffset && n.endContainer === t.endContainer && n.endOffset === t.endOffset;
  };
  function Kt(n) {
    var t = n.root, e = n.startContainer, r = n.startOffset, i = n.whitespacesOnTheLeft;
    if (e.nodeType !== y)
      return Kt({ root: t, startContainer: e.childNodes[r], startOffset: 0, whitespacesOnTheLeft: i });
    var a = r + i;
    if (e.length > a)
      return [e, a];
    var o = new it(t);
    o.nextNode = e, o.getNextTextNode();
    var u = o.getNextTextNode();
    if (!u) {
      var s = o.getPreviousTextNode();
      return [s, s.length];
    }
    return Kt({ root: t, startContainer: u, startOffset: 0, whitespacesOnTheLeft: a - e.length });
  }
  function Qt(n) {
    var t = n.root, e = n.endContainer, r = n.endOffset, i = n.whitespacesOnTheRight;
    if (e.nodeType !== y) {
      var a = !e.childNodes[r - 1], o = a ? e.childNodes[r] : e.childNodes[r - 1], u = 0;
      return a || (u = o.nodeType === y ? o.length : o.childNodes.length), Qt({ root: t, endContainer: o, endOffset: u, whitespacesOnTheRight: i });
    }
    var s = r - i;
    if (s > 0)
      return [e, s];
    var c = new it(t);
    c.previous = e, c.getPreviousTextNode();
    var l = c.getPreviousTextNode();
    return l ? Qt({ root: t, endContainer: l, endOffset: l.length, whitespacesOnTheRight: i - r }) : [c.getNextTextNode(), 0];
  }
  function Xe(n, t) {
    (t == null || t > n.length) && (t = n.length);
    for (var e = 0, r = new Array(t); e < t; e++)
      r[e] = n[e];
    return r;
  }
  function Xt(n) {
    return n = n.jquery ? n[0] : n, Ut(n, ".".concat(d.editableClass));
  }
  function bt(n) {
    for (var t = 0; (n = n.previousSibling) !== null; )
      t++;
    return t;
  }
  function Ge(n) {
    var t, e = function(i, a) {
      var o = typeof Symbol < "u" && i[Symbol.iterator] || i["@@iterator"];
      if (!o) {
        if (Array.isArray(i) || (o = function(h, g) {
          if (h) {
            if (typeof h == "string")
              return Xe(h, g);
            var v = Object.prototype.toString.call(h).slice(8, -1);
            return v === "Object" && h.constructor && (v = h.constructor.name), v === "Map" || v === "Set" ? Array.from(h) : v === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v) ? Xe(h, g) : void 0;
          }
        }(i))) {
          o && (i = o);
          var u = 0, s = function() {
          };
          return { s, n: function() {
            return u >= i.length ? { done: !0 } : { done: !1, value: i[u++] };
          }, e: function(h) {
            throw h;
          }, f: s };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var c, l = !0, f = !1;
      return { s: function() {
        o = o.call(i);
      }, n: function() {
        var h = o.next();
        return l = h.done, h;
      }, e: function(h) {
        f = !0, c = h;
      }, f: function() {
        try {
          l || o.return == null || o.return();
        } finally {
          if (f)
            throw c;
        }
      } };
    }(n.childNodes);
    try {
      for (e.s(); !(t = e.n()).done; ) {
        var r = t.value;
        if (r.nodeType === y && !Ye(r) || r.nodeType === _)
          return !1;
      }
    } catch (i) {
      e.e(i);
    } finally {
      e.f();
    }
    return !0;
  }
  function Ye(n) {
    return n.nodeType === y && !n.nodeValue;
  }
  function Je(n) {
    return n.nodeType === y && Gt(n) === 0;
  }
  function Ze(n) {
    return n.nodeType === _ && n.tagName === "BR";
  }
  function Gt(n) {
    if (n.nodeType === y)
      return Pe(n.nodeValue).length;
    var t = 0;
    return Array.from(n.childNodes).reverse().every(function(e, r, i) {
      return !(!Je(e) && !Ze(e) && (t = i.length - r, 1));
    }), t;
  }
  function kt(n, t, e) {
    if (t === n)
      return Jt(t, e);
    if (Jt(t, e)) {
      var r = bt(t);
      return kt(n, t.parentNode, r);
    }
    return !1;
  }
  function Yt(n, t, e) {
    if (t === n)
      return Zt(t, e);
    if (Zt(t, e)) {
      var r = bt(t) + 1;
      return Yt(n, t.parentNode, r);
    }
    return !1;
  }
  function Jt(n, t) {
    return n.nodeType === y ? t === 0 : n.childNodes.length === 0 || n.childNodes.length === 1 && n.firstChild.nodeType === _ && n.firstChild.getAttribute("data-editable") === "remove" || n.childNodes[t] === n.firstChild;
  }
  function Zt(n, t) {
    return n.nodeType === y ? t === n.length : n.childNodes.length === 0 || t > 0 && n.childNodes[t - 1] === n.lastChild;
  }
  function Ct(n, t, e) {
    if (t === n)
      return te(t, e);
    if (te(t, e)) {
      var r = bt(t) + 1;
      return Ct(n, t.parentNode, r);
    }
    return !1;
  }
  function te(n, t) {
    return n.nodeType === y ? t >= Pe(n.nodeValue).length : n.childNodes.length === 0 || t >= Gt(n);
  }
  function tn(n, t) {
    var e, r, i;
    if (n.nodeType !== t.nodeType || n.nodeName !== t.nodeName)
      return !1;
    for (e = 0, r = n.attributes.length; e < r; e++)
      if (i = n.attributes[e], t.getAttribute(i.name) !== i.value)
        return !1;
    return !0;
  }
  function wt(n) {
    return n.lastChild ? wt(n.lastChild) : n;
  }
  function qr(n) {
    return console.warn("Editable.js: Using obsolete function parser.latestCild(), use lastChild() instead"), wt(n);
  }
  function ee(n) {
    return n && n.nodeType === qt && n.childNodes.length === 0;
  }
  function Ur(n, t) {
    switch ((t.currentStyle || n.getComputedStyle(t, "")).display) {
      case "inline":
      case "inline-block":
        return !0;
      default:
        return !1;
    }
  }
  var zr = 0, $r = "\uFEFF";
  function en(n, t) {
    var e = n.commonAncestorContainer;
    if (e.nodeType === 3)
      return !1;
    var r = t.parentElement;
    return (r == null ? void 0 : r.parentElement) === e;
  }
  function ne(n, t) {
    var e = n.commonAncestorContainer;
    e.ownerDocument || Q("Cannot save range: range is empty");
    var r = e.ownerDocument.defaultView.document, i = r.createElement("span");
    i.id = "editable-range-boundary-".concat(++zr), i.setAttribute("data-editable", "remove"), i.style.lineHeight = "0", i.style.display = "none", i.appendChild(r.createTextNode($r));
    var a = t && en(n, n.startContainer), o = !t && en(n, n.endContainer);
    if (a) {
      var u = n.startContainer.parentElement;
      u.parentElement.insertBefore(i, u);
    } else if (o) {
      var s = n.endContainer.parentElement;
      s.parentElement.insertBefore(i, s.nextSibling);
    } else {
      var c = n.cloneRange();
      c.collapse(t), c.insertNode(i);
    }
    return i;
  }
  function nn(n, t, e, r) {
    var i = an(n, e);
    if (!i)
      return console.log("Marker element has been removed. Cannot restore selection.");
    t[r ? "setStartBefore" : "setEndBefore"](i), i.remove();
  }
  function rn(n) {
    var t, e, r;
    return n.collapsed ? t = { markerId: (r = ne(n, !1)).id, collapsed: !0 } : (r = ne(n, !1), t = { startMarkerId: (e = ne(n, !0)).id, endMarkerId: r.id, collapsed: !1 }), n.collapsed ? (n.setStartBefore(r), n.collapse(!0)) : (n.setEndBefore(r), n.setStartAfter(e)), t;
  }
  function on(n, t) {
    if (!t.restored) {
      var e = F();
      if (t.collapsed) {
        var r = an(n, t.markerId);
        if (r) {
          r.style.display = "inline";
          var i = r.previousSibling;
          i && i.nodeType === y ? (r.remove(), e.setStart(i, i.length)) : (e.setStartBefore(r), e.collapse(!0), r.remove());
        } else
          console.log("Marker element has been removed. Cannot restore selection.");
      } else
        nn(n, e, t.startMarkerId, !0), nn(n, e, t.endMarkerId, !1);
      return $t(e), e;
    }
  }
  function an(n, t) {
    return n.querySelector("#".concat(t));
  }
  function sn(n, t) {
    var e = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (!e) {
      if (Array.isArray(n) || (e = function(s, c) {
        if (s) {
          if (typeof s == "string")
            return un(s, c);
          var l = Object.prototype.toString.call(s).slice(8, -1);
          return l === "Object" && s.constructor && (l = s.constructor.name), l === "Map" || l === "Set" ? Array.from(s) : l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l) ? un(s, c) : void 0;
        }
      }(n)) || t && n && typeof n.length == "number") {
        e && (n = e);
        var r = 0, i = function() {
        };
        return { s: i, n: function() {
          return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
        }, e: function(s) {
          throw s;
        }, f: i };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var a, o = !0, u = !1;
    return { s: function() {
      e = e.call(n);
    }, n: function() {
      var s = e.next();
      return o = s.done, s;
    }, e: function(s) {
      u = !0, a = s;
    }, f: function() {
      try {
        o || e.return == null || e.return();
      } finally {
        if (u)
          throw a;
      }
    } };
  }
  function un(n, t) {
    (t == null || t > n.length) && (t = n.length);
    for (var e = 0, r = new Array(t); e < t; e++)
      r[e] = n[e];
    return r;
  }
  function ot(n, t, e) {
    return t = rn(t), e(), on(n, t);
  }
  var Kr = /\u200B/g, Qr = /\uFEFF/g, Xr = /[^\S ]/g, Gr = /^\s+$/, Yr = /^\s+/, Jr = /\s+$/;
  function at(n) {
    re(n);
  }
  function re(n) {
    var t = document.createDocumentFragment();
    st(n, "firstChild"), st(n, "lastChild");
    var e, r = sn(n.childNodes);
    try {
      for (r.s(); !(e = r.n()).done; ) {
        var i = e.value;
        if (i.nodeName === "BR" || i.textContent) {
          if (i.nodeType === _ && i.nodeName !== "BR") {
            for (var a = i; (a = a.nextSibling) !== null && tn(a, i); ) {
              var o, u = sn(a.childNodes);
              try {
                for (u.s(); !(o = u.n()).done; ) {
                  var s = o.value;
                  i.appendChild(s.cloneNode(!0));
                }
              } catch (c) {
                u.e(c);
              } finally {
                u.f();
              }
              a.remove();
            }
            re(i);
          }
          t.appendChild(i.cloneNode(!0));
        }
      }
    } catch (c) {
      r.e(c);
    } finally {
      r.f();
    }
    for (; n.firstChild; )
      n.removeChild(n.firstChild);
    n.appendChild(t);
  }
  function cn(n) {
    return n.replace(Xr, " ");
  }
  function ln(n) {
    n.innerHTML = ie(n, !0);
  }
  function ie(n, t) {
    var e = (n.nodeType === qt ? St(n) : n.innerHTML).replace(Qr, "").replace(Kr, "<br>"), r = document.createElement("div");
    return r.innerHTML = e, ae(r, t), st(r, "firstChild"), st(r, "lastChild"), r.innerHTML;
  }
  function St(n) {
    var t = document.createElement("div");
    return t.appendChild(n), t.innerHTML;
  }
  function X(n) {
    var t = document.createElement("div");
    t.innerHTML = n;
    for (var e = document.createDocumentFragment(); t.firstChild; )
      e.appendChild(t.firstChild);
    return e;
  }
  function At(n, t) {
    return n.ownerDocument !== t ? t.adoptNode(n) : n;
  }
  function oe(n) {
    for (var t = n.cloneContents().childNodes[0], e = document.createDocumentFragment(); t.childNodes.length; )
      e.appendChild(t.childNodes[0]);
    return e;
  }
  function st(n, t) {
    for (var e, r, i = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2]; r = n[t]; )
      if (r.nodeType === y) {
        if (!Gr.test(r.textContent))
          break;
        n.removeChild(r);
      } else {
        if (r.nodeName !== "BR") {
          r[t] && st(r, t, !1);
          break;
        }
        r.remove();
      }
    i && ((e = r = n[t]) === null || e === void 0 ? void 0 : e.nodeType) === y && d.trimLeadingAndTrailingWhitespaces && (r.textContent = r.textContent.replace(t.startsWith("last") ? Jr : Yr, ""));
  }
  function ae(n, t) {
    for (; n; ) {
      var e = n.nextSibling;
      if (n.nodeType === _) {
        var r = n.getAttribute("data-editable");
        n.firstChild && ae(n.firstChild, t), (r === "remove" || r === "ui-remove" && !t) && n.remove(), (r === "unwrap" || r === "ui-unwrap" && !t) && P(n), n = e;
      } else
        n = e;
    }
  }
  function H(n, t, e) {
    var r = ce(t, e), i = se(n, t, e);
    return r.concat(i);
  }
  function se(n, t, e) {
    for (var r = [], i = t.commonAncestorContainer; i !== n; )
      e && !e(i) || r.push(i), i = i.parentNode;
    return r;
  }
  function hn(n, t, e) {
    return H(n, t, function(r) {
      return r.nodeName.toUpperCase() === e.toUpperCase();
    });
  }
  function fn(n, t, e) {
    return H(n, t, function(r) {
      return r.nodeName.toUpperCase() === e.nodeName.toUpperCase() && ue(r.attributes, e.attributes);
    });
  }
  function ue(n, t) {
    if (n.length !== t.length)
      return !1;
    for (var e = 0; e < n.length; e++) {
      var r = t[n[e].name];
      if (!r || r.value !== n[e].value)
        return !1;
    }
    return !0;
  }
  function ce(n, t) {
    return zt(n, [_], t);
  }
  function dn(n, t) {
    return zt(n, [_], t).filter(function(e) {
      return Vr(n, e);
    });
  }
  function gn() {
    return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).map(function(n) {
      return n.nodeName;
    });
  }
  function Zr(n, t, e) {
    return H(n, t).some(function(r) {
      return r.nodeName === e.toUpperCase();
    });
  }
  function ti(n) {
    var t = F();
    return t.selectNodeContents(n), t;
  }
  function le(n, t, e) {
    var r, i, a = F();
    if (a.selectNodeContents(t), i = a, (r = n).compareBoundaryPoints(Range.END_TO_START, i) !== -1 || i.compareBoundaryPoints(Range.END_TO_START, r) !== -1)
      return !1;
    var o = n.toString(), u = (t.jquery ? t[0] : t).textContent;
    return e && (o = Wt(o), u = Wt(u)), o !== "" && o === u;
  }
  function vn(n, t, e) {
    return t.selectNodeContents(e), t;
  }
  function pn(n, t, e) {
    var r = fn(n, t, e);
    return r.length === 1 && le(t, r[0], "visible") ? mn(n, t, e) : he(n, t, e);
  }
  function Et(n) {
    return function(t) {
      if (!t || !t.startContainer || !t.endContainer)
        return !1;
      if (t.startContainer === t.endContainer)
        return !0;
      for (var e, r = function(a, o) {
        var u = a, s = null;
        return { next: function() {
          if (!u)
            return null;
          if (u.firstChild && s !== u.firstChild)
            s = u, u = u.firstChild;
          else if (u.nextSibling)
            s = u, u = u.nextSibling;
          else {
            for (var c = u.parentNode; c && c !== a; ) {
              if (c.nextSibling) {
                s = u = c.nextSibling;
                break;
              }
              c = c.parentNode;
            }
            c && c !== a || (s = u = null);
          }
          return u;
        } };
      }(t.commonAncestorContainer), i = !1; e = r.next(); )
        if (e.nodeType === Node.ELEMENT_NODE && !ni(e, t)) {
          i = !0;
          break;
        }
      return !i;
    }(n);
  }
  function he(n, t, e) {
    var r = ot(n, t, function() {
      de(n, t, e);
    });
    return Et(r) || (r = ot(n, r, function() {
      fe(n, r);
    })), yn(r, e), r;
  }
  function yn(n, t) {
    Et(n) ? (typeof t == "string" && (t = qe(t)), n.surroundContents(t)) : console.log("content.wrap(): can not surround range");
  }
  function P(n) {
    for (var t = (n = n.jquery ? n[0] : n).parentNode; n.firstChild; )
      t.insertBefore(n.firstChild, n);
    t.removeChild(n);
  }
  function mn(n, t, e) {
    return ot(n, t, function() {
      de(n, t, e);
    });
  }
  function bn(n, t, e) {
    return ot(n, t, function() {
      fe(n, t, e);
    });
  }
  function fe(n, t, e) {
    H(n, t).forEach(function(r) {
      r.nodeName.toUpperCase() === "BR" || e && !r.matches(e) || P(r);
    });
  }
  function de(n, t, e) {
    H(n, t).forEach(function(r) {
      r.nodeName.toUpperCase() !== "BR" && (!e || r.nodeName.toUpperCase() === e.nodeName.toUpperCase() && ue(r.attributes, e.attributes)) && P(r);
    });
  }
  function ge(n, t, e) {
    var r = document.createTextNode(t), i = n.cloneRange();
    i.collapse(e), i.insertNode(r), n[e ? "setStartBefore" : "setEndAfter"](r), $t(n);
  }
  function kn(n, t, e, r) {
    return ge(t, r || e, !1), ge(t, e, !0), t;
  }
  function ut(n, t, e) {
    if (!ve(t, e))
      return t;
    window.getSelection().rangeCount > 0 && Wr(t);
    var r = ot(n, t, function() {
      zt(t, [y], function(i) {
        return i.nodeValue.indexOf(e) >= 0;
      }).forEach(function(i) {
        i.nodeValue = i.nodeValue.replaceAll(e, "");
      });
    });
    return $t(r), r;
  }
  function ve(n, t) {
    return n.toString().indexOf(t) >= 0;
  }
  function ei(n, t, e) {
    H(n, t).forEach(function(r) {
      r.nodeName.toUpperCase() === e.toUpperCase() && P(r);
    });
  }
  function ni(n, t) {
    var e = document.createRange();
    return e.selectNodeContents(n), t.compareBoundaryPoints(Range.START_TO_START, e) <= 0 && t.compareBoundaryPoints(Range.END_TO_END, e) >= 0;
  }
  var Cn = 1, ri = {}, wn = An("nextElementSibling"), Sn = An("previousElementSibling");
  function ii(n, t) {
    var e = t.normalize, r = t.plainText, i = t.shouldSpellcheck;
    (function(a) {
      a.hasAttribute("data-editable") || (a.setAttribute("data-editable", "id-".concat(Cn)), Cn += 1);
    })(n), n.setAttribute("contenteditable", !0), n.setAttribute("spellcheck", !!i), n.setAttribute("data-plaintext", !!r), n.classList.remove(d.editableDisabledClass), n.classList.add(d.editableClass), e && at(n);
  }
  function pe(n) {
    return n.getAttribute("data-plaintext") === "true";
  }
  function An(n) {
    return function(t) {
      var e = t[n];
      return e && e.getAttribute("contenteditable") ? e : null;
    };
  }
  function ye(n, t) {
    (t == null || t > n.length) && (t = n.length);
    for (var e = 0, r = new Array(t); e < t; e++)
      r[e] = n[e];
    return r;
  }
  function En(n, t) {
    if (n) {
      if (typeof n == "string")
        return ye(n, t);
      var e = Object.prototype.toString.call(n).slice(8, -1);
      return e === "Object" && n.constructor && (e = n.constructor.name), e === "Map" || e === "Set" ? Array.from(n) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? ye(n, t) : void 0;
    }
  }
  function Tt(n) {
    return function(t) {
      if (Array.isArray(t))
        return ye(t);
    }(n) || function(t) {
      if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
        return Array.from(t);
    }(n) || En(n) || function() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }();
  }
  var M, me, Tn, xn, Nn, be, ct, ke, On, oi = [["«", "»"], ["»", "«"], ['"', '"'], ["“", "”"], ["”", "”"], ["“", "“"], ["„", "“"]], ai = [["‘", "’"], ["‹", "›"], ["‚", "‘"], ["’", "’"], ["›", "‹"], ["'", "'"], ["‘", "’"]], si = ["’", "'"], _n = /([‘’‹›‚'«»"“”„])(?![^<]*?>)/g, ui = /\s|[>\-–—«»”"“„]/, ci = /\s|[<\-–—«»”"“‘’‹›'.;?:,]/;
  function li(n, t) {
    (M = t || {}).quotes = M.quotes || [void 0, void 0], M.singleQuotes = M.singleQuotes || [void 0, void 0];
    var e = function(r) {
      return Tt(r.matchAll(_n)).map(function(i) {
        var a = i.index;
        return { char: i[1], before: a > 0 ? r[a - 1] : "", after: a + 1 < r.length ? r[a + 1] : "" };
      });
    }(n);
    return e.length > 0 ? (Rn(e, 0), function(r, i) {
      var a = 0;
      return r.replace(_n, function(o) {
        var u = i[a].replace || i[a].char;
        return a += 1, u;
      });
    }(n, e)) : n;
  }
  function Rn(n, t) {
    for (; t < n.length; ) {
      var e = hi(n, t);
      if (e) {
        if (n[t].replace = e.type === "double" ? M.quotes[0] : M.singleQuotes[0], n[e.position].replace = e.type === "double" ? M.quotes[1] : M.singleQuotes[1], e.position !== t + 1) {
          var r = n.slice(t + 1, e.position);
          r && Rn(r, 0);
        }
        t = e.position + 1;
      } else
        n[t].replace = fi(n[t].char), t += 1;
    }
  }
  function hi(n, t) {
    if (t !== n.length - 1) {
      var e = n[t], r = e.char;
      if (!e.before || ui.test(e.before)) {
        for (var i = jn(r, ai), a = jn(r, oi), o = t + 1; o < n.length; o++)
          if (n[o].after && ci.test(n[o].after) || !n[o].after) {
            if (i.includes(n[o].char))
              return { position: o, type: "single" };
            if (a.includes(n[o].char))
              return { position: o, type: "double" };
          }
      }
    }
  }
  function jn(n, t) {
    return t.filter(function(e) {
      return e[0] === n;
    }).map(function(e) {
      return e[1];
    });
  }
  function fi(n) {
    if (si.includes(n))
      return M.apostrophe;
  }
  var Bn, Ln = /^\s*$/, Ce = "<!-- BLOCK -->";
  function Mn(n) {
    var t = n.pastedHtmlRules;
    me = t.allowedElements || {}, Tn = t.allowedPlainTextElements || {}, xn = t.requiredAttributes || {}, Nn = t.transformElements || {}, On = t.blacklistedElements || [], Bn = t.keepInternalRelativeLinks || !1, ct = t.replaceQuotes || {}, be = {}, t.blockLevelElements.forEach(function(e) {
      be[e] = !0;
    }), ke = {}, t.splitIntoBlocks.forEach(function(e) {
      ke[e] = !0;
    });
  }
  function di(n, t, e) {
    var r = n.ownerDocument;
    n.setAttribute(d.pastingAttribute, !0), t.isSelection && (t = t.deleteExactSurroundingTags().deleteContainedTags().deleteContent());
    var i = r.createElement("div");
    i.innerHTML = e;
    var a = function(o) {
      var u = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).plainText, s = u !== void 0 && u;
      return In(o, { allowedElements: s ? Tn : me, keepInternalRelativeLinks: !s && Bn }).split(Ce).map(function(c) {
        return Wt((l = c, ct.quotes || ct.singleQuotes || ct.apostrophe ? li(l, ct) : l).replace(/\n/g, " ").replace(/ {2,}/g, " ").replace(/(.)\u00A0/g, function(f, h) {
          return h + (/[\u0020]/.test(h) ? " " : " ");
        }));
        var l;
      }).filter(function(c) {
        return !Ln.test(c);
      });
    }(i, { plainText: pe(n) });
    return n.removeAttribute(d.pastingAttribute), { blocks: a, cursor: t };
  }
  function In(n, t) {
    return Array.from(n.childNodes).reduce(function(e, r) {
      if (On.indexOf(r.nodeName.toLowerCase()) !== -1)
        return "";
      if (t.keepInternalRelativeLinks && r.nodeName === "A" && r.href) {
        var i = r.getAttribute("href").replace(window.location.origin, "");
        r.setAttribute("href", i);
      }
      return r.nodeType === _ ? e + function(a, o, u) {
        var s = a.nodeName.toLowerCase();
        if (function(l, f, h) {
          return h.allowedElements[l] && function(g, v) {
            var b = xn[g];
            return !b || !b.some(function(T) {
              return !v.getAttribute(T);
            });
          }(l, f);
        }(s = function(l) {
          return Nn[l] || l;
        }(s), a, u)) {
          var c = function(l, f) {
            return Array.from(f.attributes).reduce(function(h, g) {
              var v, b = g.name, T = g.value;
              return (v = me[l]) !== null && v !== void 0 && v[b] && T ? "".concat(h, " ").concat(b, '="').concat(T, '"') : h;
            }, "");
          }(s, a);
          return s === "br" ? "<".concat(s + c, ">") : Ln.test(o) ? o : "<".concat(s + c, ">").concat(o, "</").concat(s, ">");
        }
        return ke[s] ? Ce + o + Ce : be[s] ? "".concat(o, " ") : o;
      }(r, In(r, t), t) : r.nodeType === y ? e + r.nodeValue.replace(/[&<>]/g, function(a) {
        return Pr[a];
      }) : e;
    }, "");
  }
  Mn(d), document.documentElement.contentEditable;
  var gi = /(apple)?webkit\/537\.36/i.test(window.navigator.userAgent), vi = /(apple)?webkit/i.test(window.navigator.userAgent), pi = !gi && vi, yi = function(n) {
    var t = document, e = t.onselectionchange;
    if (e !== void 0)
      try {
        return t.onselectionchange = 0, t.onselectionchange === null;
      } catch {
      } finally {
        t.onselectionchange = e;
      }
    return !1;
  }(), mi = !!pi;
  function Dn(n, t) {
    var e = function(r) {
      var i = {};
      function a(o, u) {
        o.split(" ").forEach(function(s) {
          i[s] = i[s] || [], i[s].unshift(u);
        });
      }
      return { on: function(o, u) {
        if (arguments.length === 2)
          a(o, u);
        else if (arguments.length === 1)
          for (var s in o)
            a(s, o[s]);
        return this;
      }, off: function(o, u) {
        arguments.length === 2 ? function(s, c) {
          var l = i[s];
          if (l) {
            var f = l.indexOf(c);
            f < 0 || l.splice(f, 1);
          }
        }(o, u) : arguments.length === 1 ? i[o] = [] : i = {};
      }, notify: function(o, u) {
        var s = Array.from(arguments);
        r ? (u = o, o = r, s.splice(0, 1)) : s.splice(0, 2), this.switchContext && u !== this.switchContext.events.shift() && (this.switchContext = void 0);
        var c = i[u];
        c && c.every(function(l) {
          return l.apply(o, s) !== !1;
        });
      } };
    }(t);
    n.on = e.on, n.off = e.off, n.notify = e.notify;
  }
  function Fn(n) {
    return { x: n.pageXOffset !== void 0 ? n.pageXOffset : (n.document.documentElement || n.document.body.parentNode || n.document.body).scrollLeft, y: n.pageYOffset !== void 0 ? n.pageYOffset : (n.document.documentElement || n.document.body.parentNode || n.document.body).scrollTop };
  }
  var B = function() {
    function n(t, e) {
      E(this, n), this.setHost(t), this.range = e, this.isCursor = !0;
    }
    return O(n, [{ key: "getTags", value: function(t) {
      return H(this.host, this.range, t);
    } }, { key: "getTagNames", value: function(t) {
      return gn(this.getTags(t));
    } }, { key: "getTagsByName", value: function(t) {
      return hn(this.host, this.range, t);
    } }, { key: "getInnerTags", value: function(t) {
      return ce(this.range, t);
    } }, { key: "getContainedTags", value: function(t) {
      return dn(this.range, t);
    } }, { key: "getAncestorTags", value: function(t) {
      return se(this.host, this.range, t);
    } }, { key: "isAtEnd", value: function() {
      return Yt(this.host, this.range.endContainer, this.range.endOffset);
    } }, { key: "isAtTextEnd", value: function() {
      return Ct(this.host, this.range.endContainer, this.range.endOffset);
    } }, { key: "isAtLastLine", value: function() {
      var t = this.win.document.createRange();
      t.selectNodeContents(this.host), t.collapse(!1);
      var e = xt(t, this.win), r = xt(this.range, this.win);
      return Hn(e.bottom, r.bottom);
    } }, { key: "isAtFirstLine", value: function() {
      var t = this.win.document.createRange();
      t.selectNodeContents(this.host), t.collapse(!0);
      var e = xt(t, this.win), r = xt(this.range, this.win);
      return Hn(e.top, r.top);
    } }, { key: "isAtBeginning", value: function() {
      return kt(this.host, this.range.startContainer, this.range.startOffset);
    } }, { key: "insertBefore", value: function(t) {
      if (Ve(t) && (t = X(t)), !ee(t)) {
        var e = t = this.adoptElement(t);
        if (t.nodeType === qt) {
          var r = t.childNodes.length - 1;
          e = t.childNodes[r];
        }
        this.range.insertNode(t), this.range.setStartAfter(e), this.range.setEndAfter(e), this.host.normalize();
      }
    } }, { key: "insertAfter", value: function(t) {
      if (Ve(t) && (t = X(t)), !ee(t)) {
        t = this.adoptElement(t);
        var e = this.range.cloneRange();
        e.setStart(e.endContainer, e.endOffset), e.collapse(!0), e.insertNode(t), this.host.normalize();
      }
    } }, { key: "setSelection", value: function() {
      this.setVisibleSelection();
    } }, { key: "setVisibleSelection", value: function() {
      if (this.win.document.activeElement !== this.host) {
        var t = Fn(this.win), e = t.x, r = t.y;
        this.win.scrollTo(e, r);
      }
      var i = Ue(this.win);
      i.removeAllRanges(), i.addRange(this.range);
    } }, { key: "before", value: function() {
      var t = this.range.cloneRange();
      return t.collapse(!0), t.setStartBefore(this.host), oe(t);
    } }, { key: "textBefore", value: function() {
      var t = this.range.cloneRange();
      return t.collapse(!0), t.setStartBefore(this.host), t.toString();
    } }, { key: "beforeHtml", value: function() {
      return St(this.before());
    } }, { key: "after", value: function() {
      var t = this.range.cloneRange();
      return t.collapse(!1), t.setEndAfter(this.host), oe(t);
    } }, { key: "textAfter", value: function() {
      var t = this.range.cloneRange();
      return t.collapse(!1), t.setEndAfter(this.host), t.toString();
    } }, { key: "afterHtml", value: function() {
      return St(this.after());
    } }, { key: "getBoundingClientRect", value: function() {
      return this.range.getBoundingClientRect();
    } }, { key: "getCoordinates", value: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "absolute", e = this.range.getBoundingClientRect();
      if (t === "fixed")
        return e;
      var r = Fn(this.win), i = r.x, a = r.y;
      return { top: e.top + a, bottom: e.bottom + a, left: e.left + i, right: e.right + i, height: e.height, width: e.width };
    } }, { key: "moveBefore", value: function(t) {
      if (this.updateHost(t), this.range.setStartBefore(t), this.range.setEndBefore(t), this.isSelection)
        return new n(this.host, this.range);
    } }, { key: "moveAfter", value: function(t) {
      if (this.updateHost(t), this.range.setStartAfter(t), this.range.setEndAfter(t), this.isSelection)
        return new n(this.host, this.range);
    } }, { key: "moveAtBeginning", value: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.host;
      if (this.updateHost(t), this.range.selectNodeContents(t), this.range.collapse(!0), this.isSelection)
        return new n(this.host, this.range);
    } }, { key: "moveAtEnd", value: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.host;
      if (this.updateHost(t), this.range.selectNodeContents(t), this.range.collapse(!1), this.isSelection)
        return new n(this.host, this.range);
    } }, { key: "moveAtTextEnd", value: function(t) {
      return this.moveAtEnd(wt(t));
    } }, { key: "setHost", value: function(t) {
      t.jquery && (t = t[0]), this.host = t, this.win = t == null ? window : t.ownerDocument.defaultView;
    } }, { key: "updateHost", value: function(t) {
      var e = Xt(t);
      e || Q("Can not set cursor outside of an editable block"), this.setHost(e);
    } }, { key: "retainVisibleSelection", value: function(t) {
      this.save(), t(), this.restore(), this.setVisibleSelection();
    } }, { key: "save", value: function() {
      this.savedRangeInfo = rn(this.range), this.savedRangeInfo.host = this.host;
    } }, { key: "restore", value: function() {
      this.savedRangeInfo || Q("Could not restore selection"), this.host = this.savedRangeInfo.host, this.range = on(this.host, this.savedRangeInfo), this.savedRangeInfo = void 0;
    } }, { key: "equals", value: function(t) {
      return !!(t && t.host && t.host.isEqualNode(this.host) && t.range && Qe(t.range, this.range));
    } }, { key: "createElement", value: function(t) {
      var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = this.win.document.createElement(t);
      for (var i in e) {
        var a = e[i];
        r.setAttribute(i, a);
      }
      return r;
    } }, { key: "createTextNode", value: function(t) {
      return this.win.document.createTextNode(t);
    } }, { key: "adoptElement", value: function(t) {
      return At(t, this.win.document);
    } }, { key: "triggerChange", value: function() {
      var t = new Event("formatEditable", { bubbles: !0, cancelable: !1 });
      this.host.dispatchEvent(t);
    } }], [{ key: "findHost", value: function(t, e) {
      return Ut(t, e);
    } }]), n;
  }();
  function xt(n, t) {
    if (n.startContainer.nodeType !== _)
      return n.getBoundingClientRect();
    var e = t.document.createElement("span");
    e.setAttribute("doc-editable", "unwrap"), n.insertNode(e);
    var r = e.getBoundingClientRect();
    return e.remove(), r;
  }
  function Hn(n, t) {
    return n === t || Math.abs(n - t) <= 2;
  }
  function Pn(n, t) {
    return function(e) {
      if (Array.isArray(e))
        return e;
    }(n) || function(e, r) {
      var i = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
      if (i != null) {
        var a, o, u, s, c = [], l = !0, f = !1;
        try {
          if (u = (i = i.call(e)).next, r === 0) {
            if (Object(i) !== i)
              return;
            l = !1;
          } else
            for (; !(l = (a = u.call(i)).done) && (c.push(a.value), c.length !== r); l = !0)
              ;
        } catch (h) {
          f = !0, o = h;
        } finally {
          try {
            if (!l && i.return != null && (s = i.return(), Object(s) !== s))
              return;
          } finally {
            if (f)
              throw o;
          }
        }
        return c;
      }
    }(n, t) || En(n, t) || function() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }();
  }
  function Nt(n) {
    return Nt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    }, Nt(n);
  }
  function we(n, t) {
    return we = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, r) {
      return e.__proto__ = r, e;
    }, we(n, t);
  }
  const V = { extractText: function(n) {
    var t = "";
    return function(e, r, i) {
      for (var a, o = new it(e); a = o.getNext(); )
        a.nodeType === y && a.data !== "" ? i(a.data) : r && a.nodeType === _ && a.nodeName === "BR" && i(`
`);
    }(n, !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], function(e) {
      t += e;
    }), t;
  }, highlightMatches: function(n, t) {
    var e = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2];
    if (t && t.length !== 0) {
      n.normalize();
      for (var r, i, a, o = new it(n), u = 0, s = 0, c = t[u], l = []; r = o.getNext(); )
        if (r.nodeType === y && r.data !== "") {
          var f = (a = r).data, h = s + f.length;
          if (c.startIndex < h && s < c.endIndex) {
            var g, v, b = s <= c.startIndex, T = h >= c.endIndex;
            b && (i = c.id || c.startIndex), g = b ? c.startIndex - s : 0, v = T ? c.endIndex - s - g : f.length - g;
            var p = { element: a, text: f.substring(g, g + v), offset: g, length: v, isLastPortion: T, wordId: i };
            if (l.push(p), T) {
              var C = this.wrapMatch(l, c.marker, c.title);
              o.replaceCurrent(C), h = s + p.length + p.offset, l = [], (u += 1) < t.length && (c = t[u]);
            }
          }
          s = h;
        } else if (e && r.nodeType === _ && r.nodeName === "BR") {
          s += 1;
          continue;
        }
    }
  }, wrapMatch: function(n, t, e) {
    var r = this;
    return n.map(function(i) {
      return r.wrapPortion(i, t, e);
    }).pop();
  }, wrapPortion: function(n, t, e) {
    var r = F();
    r.setStart(n.element, n.offset), r.setEnd(n.element, n.offset + n.length);
    var i = t.cloneNode(!0);
    if (i.setAttribute("data-word-id", n.wordId), e && i.setAttribute("title", e), r.surroundContents(i), i.nextSibling) {
      var a = i.nextSibling;
      a.nodeType === y && a.data === "" && a.remove();
    }
    return i;
  } };
  function Vn(n, t, e, r) {
    if (!n || n === "")
      return [];
    if (r && !function(a) {
      try {
        var o;
        return !!a && a instanceof ((o = a.ownerDocument) === null || o === void 0 ? void 0 : o.defaultView.HTMLElement);
      } catch {
        return A(a) === "object" && a.nodeType === 1 && A(a.style) === "object" && A(a.ownerDocument) === "object";
      }
    }(r))
      return [];
    if (t == null || !t.length)
      return [];
    var i = (e === "word" ? ki : bi)(t);
    return Tt(n.matchAll(i)).map(function(a) {
      var o, u;
      return e === "word" ? (o = a.index + a[1].length, u = a[2]) : (o = a.index, u = a[0]), { startIndex: o, endIndex: o + u.length, match: u, marker: r };
    });
  }
  function bi() {
    var n = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).map(function(e) {
      return qn(e);
    }), t = "(".concat(n.join("|"), ")");
    return new RegExp(t, "g");
  }
  var Wn = "\\u0041-\\u005A\\u0061-\\u007A\\u0030-\\u0039\\u00AA\\u00B5\\u00BA\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF\\u0100-\\u017F\\u0180-\\u024F";
  function ki() {
    var n = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).map(function(e) {
      return qn(e);
    }), t = "([^".concat(Wn, "]|^)") + "(".concat(n.join("|"), ")") + "(?=[^".concat(Wn, "]|$)");
    return new RegExp(t, "g");
  }
  function qn(n) {
    return String(n).replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
  }
  function Ot(n, t) {
    var e = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (!e) {
      if (Array.isArray(n) || (e = function(s, c) {
        if (s) {
          if (typeof s == "string")
            return Un(s, c);
          var l = Object.prototype.toString.call(s).slice(8, -1);
          return l === "Object" && s.constructor && (l = s.constructor.name), l === "Map" || l === "Set" ? Array.from(s) : l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l) ? Un(s, c) : void 0;
        }
      }(n)) || t && n && typeof n.length == "number") {
        e && (n = e);
        var r = 0, i = function() {
        };
        return { s: i, n: function() {
          return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
        }, e: function(s) {
          throw s;
        }, f: i };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var a, o = !0, u = !1;
    return { s: function() {
      e = e.call(n);
    }, n: function() {
      var s = e.next();
      return o = s.done, s;
    }, e: function(s) {
      u = !0, a = s;
    }, f: function() {
      try {
        o || e.return == null || e.return();
      } finally {
        if (u)
          throw a;
      }
    } };
  }
  function Un(n, t) {
    (t == null || t > n.length) && (t = n.length);
    for (var e = 0, r = new Array(t); e < t; e++)
      r[e] = n[e];
    return r;
  }
  var Se = { highlightText: function(n, t, e, r) {
    if (!this.hasHighlight(n, e)) {
      var i = V.extractText(n), a = '<span class="highlight-'.concat(r, '"></span>'), o = function(u, s, c) {
        return Vn(u, [s], "text", c);
      }(i, t, Se.createMarkerNode(a, r, this.win));
      return o && o.length ? (e && (o[0].id = e), V.highlightMatches(n, o), o[0].startIndex) : void 0;
    }
  }, highlightRange: function(n, t, e, r, i, a) {
    var o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "comment";
    if (this.hasHighlight(n, e) && this.removeHighlight(n, e), V.extractText(n, !1) === "")
      return -1;
    var u = Se.createMarkerNode('<span class="highlight-'.concat(o, '"></span>'), o, this.win), s = r, c = i;
    return V.highlightMatches(n, [{ startIndex: s, endIndex: c, id: e, marker: u }], !1), a && a.notify("change", n), s;
  }, updateHighlight: function(n, t, e, r) {
    if (document.documentElement.classList) {
      var i, a = Ot(n.querySelectorAll('[data-word-id="'.concat(t, '"]')));
      try {
        for (a.s(); !(i = a.n()).done; ) {
          var o = i.value;
          r && o.classList.remove(r), e && o.classList.add(e);
        }
      } catch (u) {
        a.e(u);
      } finally {
        a.f();
      }
    }
  }, removeHighlight: function(n, t, e) {
    var r, i = Ot(n.querySelectorAll('[data-word-id="'.concat(t, '"]')));
    try {
      for (i.s(); !(r = i.n()).done; )
        P(r.value);
    } catch (a) {
      i.e(a);
    } finally {
      i.f();
    }
    n.normalize(), e && e.notify("change", n);
  }, hasHighlight: function(n, t) {
    return !!n.querySelectorAll('[data-word-id="'.concat(t, '"]')).length;
  }, extractHighlightedRanges: function(n, t) {
    var e = "[data-word-id]";
    t && (e += '[data-highlight="'.concat(t, '"]'));
    var r = n.querySelectorAll(e);
    if (r.length) {
      var i, a = {}, o = Ot(r);
      try {
        for (o.s(); !(i = o.n()).done; ) {
          var u = i.value.getAttribute("data-word-id");
          a[u] || (a[u] = n.querySelectorAll('[data-word-id="'.concat(u, '"]')));
        }
      } catch (f) {
        o.e(f);
      } finally {
        o.f();
      }
      var s = {};
      for (var c in a) {
        var l = this.extractMarkerNodePosition(n, a[c]);
        l && (s[c] = l);
      }
      return s;
    }
  }, extractMarkerNodePosition: function(n, t) {
    var e = F();
    t.length > 1 ? (e.setStartBefore(t[0]), e.setEndAfter(t[t.length - 1])) : e.selectNode(t[0]);
    var r = Ke(e, n);
    return { start: r.start, end: r.end, text: r.text, nativeRange: e };
  }, cleanupStaleMarkerNodes: function(n, t) {
    var e, r = Ot(n.querySelectorAll('span[data-highlight="'.concat(t, '"]')));
    try {
      for (r.s(); !(e = r.n()).done; ) {
        var i = e.value;
        i.textContent.length || i.remove();
      }
    } catch (a) {
      r.e(a);
    } finally {
      r.f();
    }
  }, createMarkerNode: function(n, t, e) {
    var r = qe(n, e);
    return r.setAttribute("data-editable", "ui-unwrap"), r.setAttribute("data-highlight", t), r;
  } };
  const I = Se;
  function zn(n, t) {
    (t == null || t > n.length) && (t = n.length);
    for (var e = 0, r = new Array(t); e < t; e++)
      r[e] = n[e];
    return r;
  }
  function Ci(n, t, e) {
    return t = Nt(t), function(r, i) {
      if (i && (A(i) === "object" || typeof i == "function"))
        return i;
      if (i !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return function(a) {
        if (a === void 0)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return a;
      }(r);
    }(n, $n() ? Reflect.construct(t, e || [], Nt(n).constructor) : t.apply(n, e));
  }
  function $n() {
    try {
      var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return ($n = function() {
      return !!n;
    })();
  }
  var Kn = function(n) {
    function t() {
      var e;
      return E(this, t), delete (e = Ci(this, t, arguments)).isCursor, e.isSelection = !0, e;
    }
    return function(e, r) {
      if (typeof r != "function" && r !== null)
        throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && we(e, r);
    }(t, n), O(t, [{ key: "text", value: function() {
      return this.range.toString();
    } }, { key: "html", value: function() {
      return function(e) {
        var r = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : window).document.createElement("div");
        return r.appendChild(e.cloneContents()), r.innerHTML;
      }(this.range);
    } }, { key: "isAllSelected", value: function() {
      return kt(this.host, this.range.startContainer, this.range.startOffset) && Ct(this.host, this.range.endContainer, this.range.endOffset);
    } }, { key: "getTextRange", value: function() {
      return Ke(this.range, this.host);
    } }, { key: "toString", value: function() {
      return this.range.toString();
    } }, { key: "isWrappable", value: function() {
      return Et(this.range);
    } }, { key: "getRects", value: function() {
      return this.range.getClientRects();
    } }, { key: "link", value: function(e) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      e && (r.href = e);
      var i = this.createElement(d.linkMarkup.name, d.linkMarkup.attribs);
      for (var a in r) {
        var o = r[a];
        o !== void 0 && (o === null ? i.removeAttribute(a) : i.setAttribute(a, o));
      }
      d.linkMarkup.trim && this.trimRange(), this.forceWrap(i);
    } }, { key: "trimRange", value: function() {
      var e = this.range.toString(), r = e.search(/\S|$/), i = e.search(/\S[\s]+$/), a = i === -1 ? 0 : e.length - (i + 1), o = Pn(Kt({ root: this.range.commonAncestorContainer, startContainer: this.range.startContainer, startOffset: this.range.startOffset, whitespacesOnTheLeft: r }), 2), u = o[0], s = o[1];
      this.range.setStart(u, s);
      var c = Pn(Qt({ root: this.range.commonAncestorContainer, endContainer: this.range.endContainer, endOffset: this.range.endOffset, whitespacesOnTheRight: a }), 2), l = c[0], f = c[1];
      this.range.setEnd(l, f);
    } }, { key: "unlink", value: function() {
      this.removeFormatting(d.linkMarkup.name);
    } }, { key: "toggleLink", value: function(e, r) {
      var i = this.getTagsByName(d.linkMarkup.name);
      if (i.length >= 1) {
        var a = i[0];
        this.isExactSelection(a, "visible") ? this.unlink() : this.expandTo(a);
      } else
        this.link(e, r);
    } }, { key: "highlightComment", value: function(e) {
      var r = e.highlightId, i = e.textRange;
      I.highlightRange(this.host, r, i.text, i.start, i.end, void 0, "comment");
    } }, { key: "highlight", value: function(e) {
      e.highlightId;
      var r = this.textBefore(), i = this.text(), a = I.createMarkerNode('<span class="highlight-comment"></span>', this.win);
      a.setAttribute("data-match", i);
      var o = { startIndex: r.length, endIndex: r.length + i.length, match: i, marker: a };
      V.highlightMatches(this.host, [o]);
    } }, { key: "toggle", value: function(e) {
      pe(this.host) || this.range.collapsed || (e = this.adoptElement(e), this.range = pn(this.host, this.range, e), this.setVisibleSelection());
    } }, { key: "toggleCustom", value: function(e) {
      var r = e.tagName, i = e.attributes, a = e.trim, o = a !== void 0 && a, u = this.createElement(r, i);
      o && this.trimRange(), this.toggle(u);
    } }, { key: "makeCustom", value: function(e) {
      var r = e.tagName, i = e.attributes, a = e.trim, o = a !== void 0 && a, u = this.createElement(r, i);
      o && this.trimRange(), this.forceWrap(u);
    } }, { key: "makeBold", value: function() {
      var e = this.createElement(d.boldMarkup.name, d.boldMarkup.attribs);
      d.boldMarkup.trim && this.trimRange(), this.forceWrap(e);
    } }, { key: "toggleBold", value: function() {
      var e = this.createElement(d.boldMarkup.name, d.boldMarkup.attribs);
      d.boldMarkup.trim && this.trimRange(), this.toggle(e);
    } }, { key: "giveEmphasis", value: function() {
      var e = this.createElement(d.italicMarkup.name, d.italicMarkup.attribs);
      d.italicMarkup.trim && this.trimRange(), this.forceWrap(e);
    } }, { key: "toggleEmphasis", value: function() {
      var e = this.createElement(d.italicMarkup.name, d.italicMarkup.attribs);
      d.italicMarkup.trim && this.trimRange(), this.toggle(e);
    } }, { key: "makeUnderline", value: function() {
      var e = this.createElement(d.underlineMarkup.name, d.underlineMarkup.attribs);
      d.underlineMarkup.trim && this.trimRange(), this.forceWrap(e);
    } }, { key: "toggleUnderline", value: function() {
      var e = this.createElement(d.underlineMarkup.name, d.underlineMarkup.attribs);
      d.underlineMarkup.trim && this.trimRange(), this.toggle(e);
    } }, { key: "insertCharacter", value: function(e) {
      var r = this.deleteContent(), i = r.createTextNode(e);
      return r.insertBefore(i), r.setVisibleSelection(), r;
    } }, { key: "surround", value: function(e, r) {
      this.range = kn(this.host, this.range, e, r), this.setVisibleSelection();
    } }, { key: "removeSurround", value: function(e, r) {
      this.range = ut(this.host, this.range, e), this.range = ut(this.host, this.range, r), this.setVisibleSelection();
    } }, { key: "removeChars", value: function() {
      for (var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = 0; r < e.length; r++) {
        var i = e[r];
        this.range = ut(this.host, this.range, i);
      }
      this.setVisibleSelection();
    } }, { key: "toggleSurround", value: function(e, r) {
      this.containsString(e) && this.containsString(r) ? this.removeSurround(e, r) : this.surround(e, r);
    } }, { key: "removeFormatting", value: function(e) {
      this.range = bn(this.host, this.range, e), this.setVisibleSelection();
    } }, { key: "deleteExactSurroundingTags", value: function() {
      var e, r = function(a, o) {
        var u = typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
        if (!u) {
          if (Array.isArray(a) || (u = function(g, v) {
            if (g) {
              if (typeof g == "string")
                return zn(g, v);
              var b = Object.prototype.toString.call(g).slice(8, -1);
              return b === "Object" && g.constructor && (b = g.constructor.name), b === "Map" || b === "Set" ? Array.from(g) : b === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(b) ? zn(g, v) : void 0;
            }
          }(a))) {
            u && (a = u);
            var s = 0, c = function() {
            };
            return { s: c, n: function() {
              return s >= a.length ? { done: !0 } : { done: !1, value: a[s++] };
            }, e: function(g) {
              throw g;
            }, f: c };
          }
          throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }
        var l, f = !0, h = !1;
        return { s: function() {
          u = u.call(a);
        }, n: function() {
          var g = u.next();
          return f = g.done, g;
        }, e: function(g) {
          h = !0, l = g;
        }, f: function() {
          try {
            f || u.return == null || u.return();
          } finally {
            if (h)
              throw l;
          }
        } };
      }(this.getAncestorTags().reverse());
      try {
        for (r.s(); !(e = r.n()).done; ) {
          var i = e.value;
          if (this.isExactSelection(i)) {
            i.remove();
            break;
          }
        }
      } catch (a) {
        r.e(a);
      } finally {
        r.f();
      }
      return new t(this.host, this.range);
    } }, { key: "deleteContainedTags", value: function() {
      return this.getContainedTags().forEach(function(e) {
        return e.remove();
      }), new t(this.host, this.range);
    } }, { key: "deleteContent", value: function() {
      return this.range.deleteContents(), new B(this.host, this.range);
    } }, { key: "expandTo", value: function(e) {
      this.range = vn(this.host, this.range, e), this.setVisibleSelection();
    } }, { key: "collapseAtBeginning", value: function(e) {
      return this.range.collapse(!0), this.setVisibleSelection(), new B(this.host, this.range);
    } }, { key: "collapseAtEnd", value: function(e) {
      return this.range.collapse(!1), this.setVisibleSelection(), new B(this.host, this.range);
    } }, { key: "forceWrap", value: function(e) {
      pe(this.host) || this.range.collapsed || (e = this.adoptElement(e), this.range = he(this.host, this.range, e), this.setVisibleSelection());
    } }, { key: "isExactSelection", value: function(e, r) {
      return le(this.range, e, r);
    } }, { key: "containsString", value: function(e) {
      return ve(this.range, e);
    } }, { key: "deleteCharacter", value: function(e) {
      this.range = ut(this.host, this.range, e), this.setVisibleSelection();
    } }]), t;
  }(B), Qn = function() {
    function n(t, e) {
      E(this, n), this.host = t && t.jquery ? t[0] : t, this.range = e == null ? void 0 : e.cloneRange(), this.isAnythingSelected = e !== void 0, this.isCursor = this.isAnythingSelected && e.collapsed, this.isSelection = this.isAnythingSelected && !this.isCursor;
    }
    return O(n, [{ key: "getCursor", value: function() {
      if (this.isCursor)
        return new B(this.host, this.range);
    } }, { key: "getSelection", value: function() {
      if (this.isSelection)
        return new Kn(this.host, this.range);
    } }, { key: "forceCursor", value: function() {
      return this.isSelection ? this.getSelection().deleteContent() : this.getCursor();
    } }, { key: "isDifferentFrom", value: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new n(), e = this.range, r = t.range;
      return e && r ? !Qe(e, r) : !(!e && !r);
    } }]), n;
  }(), wi = function() {
    function n(t, e) {
      E(this, n), this.dispatcher = t, this.win = e || window, this.selection = void 0, this.currentSelection = void 0, this.currentRange = void 0;
    }
    return O(n, [{ key: "syncSelection", value: function() {
      try {
        this.selection = Ue(this.win);
      } catch {
        return !1;
      }
      return !0;
    } }, { key: "getRangeContainer", value: function() {
      var t, e = this.syncSelection();
      if ((t = this.selection) !== null && t !== void 0 && t.rangeCount && e) {
        var r = this.selection.getRangeAt(0), i = Xt(r.commonAncestorContainer);
        if (i)
          return new Qn(i, r);
      }
      return new Qn();
    } }, { key: "getFreshRange", value: function() {
      return this.getRangeContainer();
    } }, { key: "getFreshSelection", value: function() {
      var t = this.getRangeContainer();
      return t.isCursor ? t.getCursor(this.win) : t.getSelection(this.win);
    } }, { key: "getSelection", value: function() {
      return this.currentSelection;
    } }, { key: "forceCursor", value: function() {
      return this.getRangeContainer().forceCursor();
    } }, { key: "selectionChanged", value: function() {
      var t = this.getRangeContainer();
      if (t.isDifferentFrom(this.currentRange)) {
        var e = this.currentSelection;
        this.currentRange = t, e && (e.isCursor && !this.currentRange.isCursor ? this.dispatcher.notify("cursor", e.host) : e.isSelection && !this.currentRange.isSelection && this.dispatcher.notify("selection", e.host)), this.currentRange.isCursor ? (this.currentSelection = new B(this.currentRange.host, this.currentRange.range), this.dispatcher.notify("cursor", this.currentSelection.host, this.currentSelection)) : this.currentRange.isSelection ? (this.currentSelection = new Kn(this.currentRange.host, this.currentRange.range), this.dispatcher.notify("selection", this.currentSelection.host, this.currentSelection)) : this.currentSelection = void 0;
      }
    } }]), n;
  }(), Ae = function() {
    function n(t) {
      E(this, n), Dn(this), this.selectionWatcher = t;
    }
    return O(n, [{ key: "dispatchKeyEvent", value: function(t, e, r) {
      switch (t.keyCode) {
        case this.key.left:
          return this.notify(e, "left", t);
        case this.key.right:
          return this.notify(e, "right", t);
        case this.key.up:
          return this.notify(e, "up", t);
        case this.key.down:
          return this.notify(e, "down", t);
        case this.key.tab:
          return t.shiftKey ? this.notify(e, "shiftTab", t) : this.notify(e, "tab", t);
        case this.key.esc:
          return this.notify(e, "esc", t);
        case this.key.backspace:
          return this.preventContenteditableBug(e, t), this.notify(e, "backspace", t);
        case this.key.delete:
          return this.preventContenteditableBug(e, t), this.notify(e, "delete", t);
        case this.key.enter:
          return t.shiftKey ? this.notify(e, "shiftEnter", t) : this.notify(e, "enter", t);
        case this.key.ctrl:
        case this.key.shift:
        case this.key.alt:
        case 224:
        case 17:
        case 91:
        case 93:
          return;
        default:
          if (t.keyCode === this.key.b && (t.ctrlKey || t.metaKey))
            return this.notify(e, "bold", t);
          if (t.keyCode === this.key.i && (t.ctrlKey || t.metaKey))
            return this.notify(e, "italic", t);
          if (this.preventContenteditableBug(e, t), !r)
            return;
          if (!t.ctrlKey && !t.metaKey)
            return this.notify(e, "character", t);
      }
    } }, { key: "preventContenteditableBug", value: function(t, e) {
      if (mi && !e.ctrlKey && !e.metaKey) {
        var r = this.selectionWatcher.getFreshRange();
        if (r.isSelection) {
          var i = n.getNodeToRemove(r.range, t);
          i && i.remove();
        }
      }
    } }], [{ key: "getNodeToRemove", value: function(t, e) {
      if (t.startOffset === 0) {
        var r = t.startContainer;
        if (r.nodeType === y && (r = r.parentNode), r !== e) {
          var i = F();
          if (i.setStartBefore(r.firstChild), i.setEndAfter(r.lastChild), o = t, !((a = i).compareBoundaryPoints(Range.START_TO_START, o) <= 0 && a.compareBoundaryPoints(Range.END_TO_END, o) >= 0)) {
            var a, o;
            if (t.startContainer.nodeType === y) {
              var u = [y, _], s = r.firstChild;
              do
                if (u.indexOf(s.nodeType) !== -1)
                  break;
              while (s = s.nextSibling);
              if (s !== t.startContainer)
                return;
            }
            var c = t.cloneRange();
            return c.setStartBefore(r), n.getNodeToRemove(c, e) || r;
          }
        }
      }
    } }]), n;
  }();
  function Xn(n, t) {
    var e = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (!e) {
      if (Array.isArray(n) || (e = function(s, c) {
        if (s) {
          if (typeof s == "string")
            return Gn(s, c);
          var l = Object.prototype.toString.call(s).slice(8, -1);
          return l === "Object" && s.constructor && (l = s.constructor.name), l === "Map" || l === "Set" ? Array.from(s) : l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l) ? Gn(s, c) : void 0;
        }
      }(n)) || t && n && typeof n.length == "number") {
        e && (n = e);
        var r = 0, i = function() {
        };
        return { s: i, n: function() {
          return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
        }, e: function(s) {
          throw s;
        }, f: i };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var a, o = !0, u = !1;
    return { s: function() {
      e = e.call(n);
    }, n: function() {
      var s = e.next();
      return o = s.done, s;
    }, e: function(s) {
      u = !0, a = s;
    }, f: function() {
      try {
        o || e.return == null || e.return();
      } finally {
        if (u)
          throw a;
      }
    } };
  }
  function Gn(n, t) {
    (t == null || t > n.length) && (t = n.length);
    for (var e = 0, r = new Array(t); e < t; e++)
      r[e] = n[e];
    return r;
  }
  Ae.key = Ae.prototype.key = { left: 37, up: 38, right: 39, down: 40, tab: 9, esc: 27, backspace: 8, delete: 46, enter: 13, shift: 16, ctrl: 17, alt: 18, b: 66, i: 73 };
  var _t = !1, Si = function() {
    function n(t) {
      E(this, n);
      var e = t.win;
      Dn(this, t), this.supportsInputEvent = !1, this.document = e.document, this.config = t.config, this.editable = t, this.editableSelector = t.editableSelector, this.selectionWatcher = new wi(this, e), this.keyboard = new Ae(this.selectionWatcher), this.activeListeners = [], this.setup(), this.getEditableBlockByEvent = function(r) {
        return Ut(r.target, t.editableSelector);
      };
    }
    return O(n, [{ key: "setupDocumentListener", value: function(t, e) {
      var r = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], i = { event: t, listener: e.bind(this), capture: r };
      return this.activeListeners.push(i), this.document.addEventListener(t, i.listener, r), this;
    } }, { key: "setup", value: function() {
      this.setupKeyboardEvents(), this.setupEventListeners();
    } }, { key: "unload", value: function() {
      this.off();
      var t, e = Xn(this.activeListeners);
      try {
        for (e.s(); !(t = e.n()).done; ) {
          var r = t.value;
          this.document.removeEventListener(r.event, r.listener, r.capture);
        }
      } catch (i) {
        e.e(i);
      } finally {
        e.f();
      }
      this.activeListeners.length = 0;
    } }, { key: "suspend", value: function() {
      if (!this.suspended) {
        this.suspended = !0;
        var t, e = Xn(this.activeListeners);
        try {
          for (e.s(); !(t = e.n()).done; ) {
            var r = t.value;
            this.document.removeEventListener(r.event, r.listener, r.capture);
          }
        } catch (i) {
          e.e(i);
        } finally {
          e.f();
        }
        this.activeListeners.length = 0;
      }
    } }, { key: "continue", value: function() {
      this.suspended && (this.suspended = !1, this.setupEventListeners());
    } }, { key: "setupEventListeners", value: function() {
      this.setupElementListeners(), this.setupKeydownListener(), yi ? this.setupSelectionChangeListeners() : this.setupSelectionChangeFallbackListeners();
    } }, { key: "setupElementListeners", value: function() {
      this.setupDocumentListener("focus", function(t) {
        var e = this.getEditableBlockByEvent(t);
        e && (t.target.getAttribute(d.pastingAttribute) || (this.selectionWatcher.syncSelection(), this.notify("focus", e)));
      }, !0).setupDocumentListener("blur", function(t) {
        var e = this.getEditableBlockByEvent(t);
        e && (e.getAttribute(d.pastingAttribute) || this.notify("blur", e));
      }, !0).setupDocumentListener("copy", function(t) {
        var e = this.getEditableBlockByEvent(t);
        if (e) {
          var r = this.selectionWatcher.getFreshSelection();
          r && r.isSelection && this.notify("clipboard", e, "copy", r);
        }
      }).setupDocumentListener("cut", function(t) {
        var e = this.getEditableBlockByEvent(t);
        if (e) {
          var r = this.selectionWatcher.getFreshSelection();
          r && r.isSelection && (this.notify("clipboard", e, "cut", r), this.triggerChangeEvent(e));
        }
      }).setupDocumentListener("paste", function(t) {
        var e = this.getEditableBlockByEvent(t);
        if (e) {
          t.preventDefault();
          var r, i = this.selectionWatcher.getFreshSelection(), a = t.clipboardData.getData("text/html") || t.clipboardData.getData("text/plain"), o = di(e, i, a), u = o.blocks, s = o.cursor;
          u.length ? (r = t.target.innerText, /\S+\s{1}$/.test(r) && s.retainVisibleSelection(function() {
            e.innerHTML = function(c, l, f) {
              if (!c)
                return "";
              var h = (c = "".concat(c)).lastIndexOf("&nbsp;");
              return h === -1 ? c : "".concat(c.slice(0, h)).concat(" ").concat(c.slice(h + 6));
            }(e.innerHTML);
          }), this.notify("paste", e, u, s), this.notify("change", e)) : s.setVisibleSelection();
        }
      }).setupDocumentListener("input", function(t) {
        var e = this.getEditableBlockByEvent(t);
        e && (_t ? this.notify("change", e) : _t = !0);
      }).setupDocumentListener("formatEditable", function(t) {
        var e = this.getEditableBlockByEvent(t);
        e && this.notify("change", e);
      });
    } }, { key: "triggerChangeEvent", value: function(t) {
      _t || this.notify("change", t);
    } }, { key: "dispatchSwitchEvent", value: function(t, e, r) {
      if (!(t.altKey || t.ctrlKey || t.metaKey || t.shiftKey)) {
        var i = this.selectionWatcher.getFreshSelection();
        i && !i.isSelection && (this.switchContext ? this.switchContext.events = ["cursor"] : this.switchContext = { positionX: i.getBoundingClientRect().left, events: ["cursor"] }, r === "up" && i.isAtFirstLine() && (t.preventDefault(), t.stopPropagation(), this.switchContext.events = ["switch", "blur", "focus", "cursor"], this.notify("switch", e, r, i)), r === "down" && i.isAtLastLine() && (t.preventDefault(), t.stopPropagation(), this.switchContext.events = ["switch", "blur", "focus", "cursor"], this.notify("switch", e, r, i)));
      }
    } }, { key: "setupKeydownListener", value: function() {
      this.setupDocumentListener("keydown", function(t) {
        var e = this.getEditableBlockByEvent(t);
        if (e) {
          var r = !_t;
          this.keyboard.dispatchKeyEvent(t, e, r);
        }
      }, !0);
    } }, { key: "setupKeyboardEvents", value: function() {
      var t = this;
      this.keyboard.on("up", function(e) {
        t.dispatchSwitchEvent(e, this, "up");
      }).on("down", function(e) {
        t.dispatchSwitchEvent(e, this, "down");
      }).on("backspace", function(e) {
        var r = t.selectionWatcher.getFreshRange();
        if (!r.isCursor)
          return t.triggerChangeEvent(this);
        var i = r.getCursor();
        if (!i.isAtBeginning())
          return t.triggerChangeEvent(this);
        e.preventDefault(), e.stopPropagation(), t.notify("merge", this, "before", i);
      }).on("delete", function(e) {
        var r = t.selectionWatcher.getFreshRange();
        if (!r.isCursor)
          return t.triggerChangeEvent(this);
        var i = r.getCursor();
        if (!i.isAtTextEnd())
          return t.triggerChangeEvent(this);
        e.preventDefault(), e.stopPropagation(), t.notify("merge", this, "after", i);
      }).on("enter", function(e) {
        e.preventDefault(), e.stopPropagation();
        var r = t.selectionWatcher.getFreshRange().forceCursor();
        r.isAtTextEnd() ? t.notify("insert", this, "after", r) : r.isAtBeginning() ? t.notify("insert", this, "before", r) : t.notify("split", this, r.before(), r.after(), r);
      }).on("shiftEnter", function(e) {
        e.preventDefault(), e.stopPropagation();
        var r = t.selectionWatcher.forceCursor();
        t.notify("newline", this, r);
      }).on("bold", function(e) {
        e.preventDefault(), e.stopPropagation();
        var r = t.selectionWatcher.getFreshSelection();
        r.isSelection && t.notify("toggleBold", r);
      }).on("italic", function(e) {
        e.preventDefault(), e.stopPropagation();
        var r = t.selectionWatcher.getFreshSelection();
        r.isSelection && t.notify("toggleEmphasis", r);
      }).on("character", function(e) {
        t.notify("change", this);
      });
    } }, { key: "setupSelectionChangeListeners", value: function() {
      var t = this, e = !1, r = !1, i = this.selectionWatcher;
      this.setupDocumentListener("selectionchange", function(a) {
        var o = t.selectionWatcher.getFreshSelection();
        o && o.isSelection && o.isAtBeginning() && o.isAtEnd() ? t.notify("selectToBoundary", o.host, a, "both") : o && o.isSelection && o.isAtBeginning() ? t.notify("selectToBoundary", o.host, a, "start") : o && o.isSelection && o.isAtEnd() && t.notify("selectToBoundary", o.host, a, "end"), r ? e = !0 : i.selectionChanged();
      }), this.setupDocumentListener("mousedown", function(a) {
        this.getEditableBlockByEvent(a) && (this.config.mouseMoveSelectionChanges === !1 && (r = !0, setTimeout(function() {
          return i.selectionChanged();
        }, 0)), this.document.addEventListener("mouseup", function() {
          r = !1, e && (e = !1, i.selectionChanged());
        }, { capture: !0, once: !0 }));
      });
    } }, { key: "setupSelectionChangeFallbackListeners", value: function() {
      var t = this;
      this.setupDocumentListener("mouseup", function() {
        setTimeout(function() {
          return t.selectionWatcher.selectionChanged();
        }, 0);
      }), this.setupDocumentListener("keyup", function(e) {
        t.getEditableBlockByEvent(e) && t.selectionWatcher.selectionChanged();
      });
    } }]), n;
  }();
  const Rt = function(n, t) {
    return n === t || n != n && t != t;
  }, jt = function(n, t) {
    for (var e = n.length; e--; )
      if (Rt(n[e][0], t))
        return e;
    return -1;
  };
  var Ai = Array.prototype.splice;
  function G(n) {
    var t = -1, e = n == null ? 0 : n.length;
    for (this.clear(); ++t < e; ) {
      var r = n[t];
      this.set(r[0], r[1]);
    }
  }
  G.prototype.clear = function() {
    this.__data__ = [], this.size = 0;
  }, G.prototype.delete = function(n) {
    var t = this.__data__, e = jt(t, n);
    return !(e < 0 || (e == t.length - 1 ? t.pop() : Ai.call(t, e, 1), --this.size, 0));
  }, G.prototype.get = function(n) {
    var t = this.__data__, e = jt(t, n);
    return e < 0 ? void 0 : t[e][1];
  }, G.prototype.has = function(n) {
    return jt(this.__data__, n) > -1;
  }, G.prototype.set = function(n, t) {
    var e = this.__data__, r = jt(e, n);
    return r < 0 ? (++this.size, e.push([n, t])) : e[r][1] = t, this;
  };
  const Bt = G, Yn = typeof Vt == "object" && Vt && Vt.Object === Object && Vt;
  var Ei = typeof self == "object" && self && self.Object === Object && self;
  const Y = Yn || Ei || Function("return this")(), Lt = Y.Symbol;
  var Jn = Object.prototype, Ti = Jn.hasOwnProperty, xi = Jn.toString, lt = Lt ? Lt.toStringTag : void 0, Ni = Object.prototype.toString, Zn = Lt ? Lt.toStringTag : void 0;
  const Mt = function(n) {
    return n == null ? n === void 0 ? "[object Undefined]" : "[object Null]" : Zn && Zn in Object(n) ? function(t) {
      var e = Ti.call(t, lt), r = t[lt];
      try {
        t[lt] = void 0;
        var i = !0;
      } catch {
      }
      var a = xi.call(t);
      return i && (e ? t[lt] = r : delete t[lt]), a;
    }(n) : function(t) {
      return Ni.call(t);
    }(n);
  }, z = function(n) {
    var t = typeof n;
    return n != null && (t == "object" || t == "function");
  }, Ee = function(n) {
    if (!z(n))
      return !1;
    var t = Mt(n);
    return t == "[object Function]" || t == "[object GeneratorFunction]" || t == "[object AsyncFunction]" || t == "[object Proxy]";
  }, Te = Y["__core-js_shared__"];
  var tr, er = (tr = /[^.]+$/.exec(Te && Te.keys && Te.keys.IE_PROTO || "")) ? "Symbol(src)_1." + tr : "", Oi = Function.prototype.toString, _i = /^\[object .+?Constructor\]$/, Ri = Function.prototype, ji = Object.prototype, Bi = Ri.toString, Li = ji.hasOwnProperty, Mi = RegExp("^" + Bi.call(Li).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
  const xe = function(n, t) {
    var e = function(r, i) {
      return r == null ? void 0 : r[i];
    }(n, t);
    return function(r) {
      return !(!z(r) || (i = r, er && er in i)) && (Ee(r) ? Mi : _i).test(function(a) {
        if (a != null) {
          try {
            return Oi.call(a);
          } catch {
          }
          try {
            return a + "";
          } catch {
          }
        }
        return "";
      }(r));
      var i;
    }(e) ? e : void 0;
  }, nr = xe(Y, "Map"), ht = xe(Object, "create");
  var Ii = Object.prototype.hasOwnProperty, Di = Object.prototype.hasOwnProperty;
  function J(n) {
    var t = -1, e = n == null ? 0 : n.length;
    for (this.clear(); ++t < e; ) {
      var r = n[t];
      this.set(r[0], r[1]);
    }
  }
  J.prototype.clear = function() {
    this.__data__ = ht ? ht(null) : {}, this.size = 0;
  }, J.prototype.delete = function(n) {
    var t = this.has(n) && delete this.__data__[n];
    return this.size -= t ? 1 : 0, t;
  }, J.prototype.get = function(n) {
    var t = this.__data__;
    if (ht) {
      var e = t[n];
      return e === "__lodash_hash_undefined__" ? void 0 : e;
    }
    return Ii.call(t, n) ? t[n] : void 0;
  }, J.prototype.has = function(n) {
    var t = this.__data__;
    return ht ? t[n] !== void 0 : Di.call(t, n);
  }, J.prototype.set = function(n, t) {
    var e = this.__data__;
    return this.size += this.has(n) ? 0 : 1, e[n] = ht && t === void 0 ? "__lodash_hash_undefined__" : t, this;
  };
  const rr = J, It = function(n, t) {
    var e, r, i = n.__data__;
    return ((r = typeof (e = t)) == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null) ? i[typeof t == "string" ? "string" : "hash"] : i.map;
  };
  function Z(n) {
    var t = -1, e = n == null ? 0 : n.length;
    for (this.clear(); ++t < e; ) {
      var r = n[t];
      this.set(r[0], r[1]);
    }
  }
  Z.prototype.clear = function() {
    this.size = 0, this.__data__ = { hash: new rr(), map: new (nr || Bt)(), string: new rr() };
  }, Z.prototype.delete = function(n) {
    var t = It(this, n).delete(n);
    return this.size -= t ? 1 : 0, t;
  }, Z.prototype.get = function(n) {
    return It(this, n).get(n);
  }, Z.prototype.has = function(n) {
    return It(this, n).has(n);
  }, Z.prototype.set = function(n, t) {
    var e = It(this, n), r = e.size;
    return e.set(n, t), this.size += e.size == r ? 0 : 1, this;
  };
  const Fi = Z;
  function tt(n) {
    var t = this.__data__ = new Bt(n);
    this.size = t.size;
  }
  tt.prototype.clear = function() {
    this.__data__ = new Bt(), this.size = 0;
  }, tt.prototype.delete = function(n) {
    var t = this.__data__, e = t.delete(n);
    return this.size = t.size, e;
  }, tt.prototype.get = function(n) {
    return this.__data__.get(n);
  }, tt.prototype.has = function(n) {
    return this.__data__.has(n);
  }, tt.prototype.set = function(n, t) {
    var e = this.__data__;
    if (e instanceof Bt) {
      var r = e.__data__;
      if (!nr || r.length < 199)
        return r.push([n, t]), this.size = ++e.size, this;
      e = this.__data__ = new Fi(r);
    }
    return e.set(n, t), this.size = e.size, this;
  };
  const Hi = tt, Dt = function() {
    try {
      var n = xe(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch {
    }
  }(), Ne = function(n, t, e) {
    t == "__proto__" && Dt ? Dt(n, t, { configurable: !0, enumerable: !0, value: e, writable: !0 }) : n[t] = e;
  }, Oe = function(n, t, e) {
    (e !== void 0 && !Rt(n[t], e) || e === void 0 && !(t in n)) && Ne(n, t, e);
  };
  var ir = L && !L.nodeType && L, or = ir && j && !j.nodeType && j, ar = or && or.exports === ir ? Y.Buffer : void 0;
  ar && ar.allocUnsafe;
  const sr = Y.Uint8Array;
  var ur = Object.create;
  const Pi = function() {
    function n() {
    }
    return function(t) {
      if (!z(t))
        return {};
      if (ur)
        return ur(t);
      n.prototype = t;
      var e = new n();
      return n.prototype = void 0, e;
    };
  }(), cr = (lr = Object.getPrototypeOf, hr = Object, function(n) {
    return lr(hr(n));
  });
  var lr, hr, Vi = Object.prototype;
  const fr = function(n) {
    var t = n && n.constructor;
    return n === (typeof t == "function" && t.prototype || Vi);
  }, ft = function(n) {
    return n != null && typeof n == "object";
  }, dr = function(n) {
    return ft(n) && Mt(n) == "[object Arguments]";
  };
  var gr = Object.prototype, Wi = gr.hasOwnProperty, qi = gr.propertyIsEnumerable;
  const _e = dr(function() {
    return arguments;
  }()) ? dr : function(n) {
    return ft(n) && Wi.call(n, "callee") && !qi.call(n, "callee");
  }, Re = Array.isArray, vr = function(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= 9007199254740991;
  }, je = function(n) {
    return n != null && vr(n.length) && !Ee(n);
  };
  var pr = L && !L.nodeType && L, yr = pr && j && !j.nodeType && j, mr = yr && yr.exports === pr ? Y.Buffer : void 0;
  const br = (mr ? mr.isBuffer : void 0) || function() {
    return !1;
  };
  var Ui = Function.prototype, zi = Object.prototype, kr = Ui.toString, $i = zi.hasOwnProperty, Ki = kr.call(Object), m = {};
  m["[object Float32Array]"] = m["[object Float64Array]"] = m["[object Int8Array]"] = m["[object Int16Array]"] = m["[object Int32Array]"] = m["[object Uint8Array]"] = m["[object Uint8ClampedArray]"] = m["[object Uint16Array]"] = m["[object Uint32Array]"] = !0, m["[object Arguments]"] = m["[object Array]"] = m["[object ArrayBuffer]"] = m["[object Boolean]"] = m["[object DataView]"] = m["[object Date]"] = m["[object Error]"] = m["[object Function]"] = m["[object Map]"] = m["[object Number]"] = m["[object Object]"] = m["[object RegExp]"] = m["[object Set]"] = m["[object String]"] = m["[object WeakMap]"] = !1;
  var Cr = L && !L.nodeType && L, dt = Cr && j && !j.nodeType && j, Be = dt && dt.exports === Cr && Yn.process, wr = function() {
    try {
      return dt && dt.require && dt.require("util").types || Be && Be.binding && Be.binding("util");
    } catch {
    }
  }(), Sr = wr && wr.isTypedArray;
  const Ar = Sr ? function(n) {
    return function(t) {
      return n(t);
    };
  }(Sr) : function(n) {
    return ft(n) && vr(n.length) && !!m[Mt(n)];
  }, Le = function(n, t) {
    if ((t !== "constructor" || typeof n[t] != "function") && t != "__proto__")
      return n[t];
  };
  var Qi = Object.prototype.hasOwnProperty;
  const Xi = function(n, t, e) {
    var r = n[t];
    Qi.call(n, t) && Rt(r, e) && (e !== void 0 || t in n) || Ne(n, t, e);
  };
  var Gi = /^(?:0|[1-9]\d*)$/;
  const Er = function(n, t) {
    var e = typeof n;
    return !!(t = t ?? 9007199254740991) && (e == "number" || e != "symbol" && Gi.test(n)) && n > -1 && n % 1 == 0 && n < t;
  };
  var Yi = Object.prototype.hasOwnProperty;
  const Tr = function(n) {
    return je(n) ? function(t, e) {
      var r = Re(t), i = !r && _e(t), a = !r && !i && br(t), o = !r && !i && !a && Ar(t), u = r || i || a || o, s = u ? function(f, h) {
        for (var g = -1, v = Array(f); ++g < f; )
          v[g] = h(g);
        return v;
      }(t.length, String) : [], c = s.length;
      for (var l in t)
        u && (l == "length" || a && (l == "offset" || l == "parent") || o && (l == "buffer" || l == "byteLength" || l == "byteOffset") || Er(l, c)) || s.push(l);
      return s;
    }(n) : function(t) {
      if (!z(t))
        return function(a) {
          var o = [];
          if (a != null)
            for (var u in Object(a))
              o.push(u);
          return o;
        }(t);
      var e = fr(t), r = [];
      for (var i in t)
        (i != "constructor" || !e && Yi.call(t, i)) && r.push(i);
      return r;
    }(n);
  }, Ji = function n(t, e, r, i, a) {
    t !== e && function(o, u, s) {
      for (var c = -1, l = Object(o), f = s(o), h = f.length; h--; ) {
        var g = f[++c];
        if (u(l[g], g) === !1)
          break;
      }
    }(e, function(o, u) {
      if (a || (a = new Hi()), z(o))
        (function(c, l, f, h, g, v, b) {
          var T, p = Le(c, f), C = Le(l, f), et = b.get(C);
          if (et)
            Oe(c, f, et);
          else {
            var S = v ? v(p, C, f + "", c, l, b) : void 0, $ = S === void 0;
            if ($) {
              var nt = Re(C), pt = !nt && br(C), Ht = !nt && !pt && Ar(C);
              S = C, nt || pt || Ht ? Re(p) ? S = p : ft(T = p) && je(T) ? S = function(w, R) {
                var x = -1, N = w.length;
                for (R || (R = Array(N)); ++x < N; )
                  R[x] = w[x];
                return R;
              }(p) : pt ? ($ = !1, S = function(w, R) {
                return w.slice();
              }(C)) : Ht ? ($ = !1, S = function(w, R) {
                var x, N, Ir = (N = new (x = w.buffer).constructor(x.byteLength), new sr(N).set(new sr(x)), N);
                return new w.constructor(Ir, w.byteOffset, w.length);
              }(C)) : S = [] : function(w) {
                if (!ft(w) || Mt(w) != "[object Object]")
                  return !1;
                var R = cr(w);
                if (R === null)
                  return !0;
                var x = $i.call(R, "constructor") && R.constructor;
                return typeof x == "function" && x instanceof x && kr.call(x) == Ki;
              }(C) || _e(C) ? (S = p, _e(p) ? S = function(w) {
                return function(R, x, N, Ir) {
                  var lo = !N;
                  N || (N = {});
                  for (var Dr = -1, ho = x.length; ++Dr < ho; ) {
                    var De = x[Dr], Pt = void 0;
                    Pt === void 0 && (Pt = R[De]), lo ? Ne(N, De, Pt) : Xi(N, De, Pt);
                  }
                  return N;
                }(w, Tr(w));
              }(p) : z(p) && !Ee(p) || (S = function(w) {
                return typeof w.constructor != "function" || fr(w) ? {} : Pi(cr(w));
              }(C))) : $ = !1;
            }
            $ && (b.set(C, S), g(S, C, h, v, b), b.delete(C)), Oe(c, f, S);
          }
        })(t, e, u, r, n, i, a);
      else {
        var s = i ? i(Le(t, u), o, u + "", t, e, a) : void 0;
        s === void 0 && (s = o), Oe(t, u, s);
      }
    }, Tr);
  }, xr = function(n) {
    return n;
  };
  var Nr = Math.max;
  const Zi = Dt ? function(n, t) {
    return Dt(n, "toString", { configurable: !0, enumerable: !1, value: (e = t, function() {
      return e;
    }), writable: !0 });
    var e;
  } : xr;
  var to = Date.now;
  const eo = function(n) {
    var t = 0, e = 0;
    return function() {
      var r = to(), i = 16 - (r - e);
      if (e = r, i > 0) {
        if (++t >= 800)
          return arguments[0];
      } else
        t = 0;
      return n.apply(void 0, arguments);
    };
  }(Zi), no = (Me = function(n, t, e) {
    Ji(n, t, e);
  }, function(n, t) {
    return eo(function(e, r, i) {
      return r = Nr(r === void 0 ? e.length - 1 : r, 0), function() {
        for (var a = arguments, o = -1, u = Nr(a.length - r, 0), s = Array(u); ++o < u; )
          s[o] = a[r + o];
        o = -1;
        for (var c = Array(r + 1); ++o < r; )
          c[o] = a[o];
        return c[r] = i(s), function(l, f, h) {
          switch (h.length) {
            case 0:
              return l.call(f);
            case 1:
              return l.call(f, h[0]);
            case 2:
              return l.call(f, h[0], h[1]);
            case 3:
              return l.call(f, h[0], h[1], h[2]);
          }
          return l.apply(f, h);
        }(e, this, c);
      };
    }(n, void 0, xr), n + "");
  }(function(n, t) {
    var e = -1, r = t.length, i = r > 1 ? t[r - 1] : void 0, a = r > 2 ? t[2] : void 0;
    for (i = Me.length > 3 && typeof i == "function" ? (r--, i) : void 0, a && function(u, s, c) {
      if (!z(c))
        return !1;
      var l = typeof s;
      return !!(l == "number" ? je(c) && Er(s, c.length) : l == "string" && s in c) && Rt(c[s], u);
    }(t[0], t[1], a) && (i = r < 3 ? void 0 : i, r = 1), n = Object(n); ++e < r; ) {
      var o = t[e];
      o && Me(n, o, e);
    }
    return n;
  }));
  var Me, ro = function() {
    function n(t) {
      E(this, n), this.spellcheckService = t;
    }
    return O(n, [{ key: "check", value: function(t, e) {
      if (!t)
        return e(null);
      var r = cn(t);
      this.spellcheckService(r, function(i) {
        i && i.length > 0 ? e(null, i) : e(null);
      });
    } }]), n;
  }(), io = { A0: "no-break space", 2e3: "en quad", 2001: "em quad", 2002: "en space", 2003: "em space", 2004: "three-per-em space", 2005: "four-per-em space", 2006: "six-per-em space", 2007: "figure space", 2008: "punctuation space", 2009: "thin space", "200A": "hair space", "202F": "narrow no-break space", "205F": "medium mathematical space", 3e3: "ideographic space" }, oo = new RegExp("[".concat("\\u2000-\\u200A\\u202F\\u205F\\u3000", "]"), "g"), ao = function() {
    function n(t) {
      E(this, n), this.marker = t;
    }
    return O(n, [{ key: "findMatches", value: function(t) {
      var e = this;
      if (t)
        return Tt(t.matchAll(oo)).map(function(r) {
          return e.prepareMatch(r);
        });
    } }, { key: "prepareMatch", value: function(t) {
      var e, r = t.index, i = (e = t[0].charCodeAt(0), "".concat(e.toString(16).toUpperCase())), a = io[i];
      return { startIndex: r, endIndex: r + t.length, match: t[0], title: "".concat(a, " (\\u").concat(i, ")"), marker: this.marker };
    } }]), n;
  }(), so = function() {
    function n() {
      E(this, n), this.matches = [];
    }
    return O(n, [{ key: "addMatches", value: function(t) {
      t != null && t.length && (this.matches = function(e, r) {
        for (var i, a = e.length, o = r.length, u = -1, s = [], c = { a1: e, i1: 0, a2: r, i2: 0 }; c.i1 < a || c.i2 < o; )
          (i = uo(c)).startIndex >= u && s.push(i), u = i.endIndex;
        return s;
      }(this.matches, t));
    } }]), n;
  }();
  function uo(n) {
    var t = n.i1, e = n.i2, r = n.a1[t], i = n.a2[e];
    return r && i && r.startIndex < i.startIndex ? (n.i1 = t + 1, r) : r && i ? (n.i2 = e + 1, i) : r ? (n.i1 = t + 1, r) : i ? (n.i2 = e + 1, i) : void 0;
  }
  function Or(n, t) {
    var e = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (!e) {
      if (Array.isArray(n) || (e = function(s, c) {
        if (s) {
          if (typeof s == "string")
            return _r(s, c);
          var l = Object.prototype.toString.call(s).slice(8, -1);
          return l === "Object" && s.constructor && (l = s.constructor.name), l === "Map" || l === "Set" ? Array.from(s) : l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l) ? _r(s, c) : void 0;
        }
      }(n)) || t && n && typeof n.length == "number") {
        e && (n = e);
        var r = 0, i = function() {
        };
        return { s: i, n: function() {
          return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
        }, e: function(s) {
          throw s;
        }, f: i };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var a, o = !0, u = !1;
    return { s: function() {
      e = e.call(n);
    }, n: function() {
      var s = e.next();
      return o = s.done, s;
    }, e: function(s) {
      u = !0, a = s;
    }, f: function() {
      try {
        o || e.return == null || e.return();
      } finally {
        if (u)
          throw a;
      }
    } };
  }
  function _r(n, t) {
    (t == null || t > n.length) && (t = n.length);
    for (var e = 0, r = new Array(t); e < t; e++)
      r[e] = n[e];
    return r;
  }
  var co = function() {
    function n(t, e, r) {
      E(this, n), this.editable = t, this.win = t.win, this.focusedEditableHost = void 0, this.currentlyCheckedEditableHost = void 0, this.timeout = {}, this.config = no({}, { checkOnInit: !1, checkOnFocus: !1, checkOnChange: !0, throttle: 1e3, removeOnCorrection: !0, spellcheck: { marker: '<span class="highlight-spellcheck"></span>', throttle: 1e3, spellcheckService: function() {
      } }, whitespace: { marker: '<span class="highlight-whitespace"></span>' } }, e);
      var i = this.config.spellcheck.spellcheckService, a = this.config.spellcheck.marker, o = this.config.whitespace.marker, u = I.createMarkerNode(o, "whitespace", this.win);
      this.spellcheckMarkerNode = I.createMarkerNode(a, "spellcheck", this.win), this.spellcheckService = new ro(i), this.whitespace = new ao(u), this.setupListeners();
    }
    return O(n, [{ key: "setupListeners", value: function() {
      var t = this;
      this.config.checkOnFocus && (this.editable.on("focus", function() {
        return t.onFocus.apply(t, arguments);
      }), this.editable.on("blur", function() {
        return t.onBlur.apply(t, arguments);
      })), (this.config.checkOnChange || this.config.removeOnCorrection) && this.editable.on("change", function() {
        return t.onChange.apply(t, arguments);
      }), this.config.checkOnInit && this.editable.on("init", function() {
        return t.onInit.apply(t, arguments);
      });
    } }, { key: "onInit", value: function(t) {
      this.highlight(t);
    } }, { key: "onFocus", value: function(t) {
      this.focusedEditableHost !== t && (this.focusedEditableHost = t, this.editableHasChanged(t));
    } }, { key: "onBlur", value: function(t) {
      this.focusedEditableHost === t && (this.focusedEditableHost = void 0);
    } }, { key: "onChange", value: function(t) {
      this.config.checkOnChange && this.editableHasChanged(t, this.config.throttle), this.config.removeOnCorrection && this.removeHighlightsAtCursor(t);
    } }, { key: "editableHasChanged", value: function(t, e) {
      var r = this;
      this.timeout.id && this.timeout.editableHost === t && clearTimeout(this.timeout.id);
      var i = setTimeout(function() {
        r.highlight(t), r.timeout = {};
      }, e || 0);
      this.timeout = { id: i, editableHost: t };
    } }, { key: "highlight", value: function(t) {
      var e = this, r = V.extractText(t);
      this.spellcheckService.check(r, function(i, a) {
        if (!i && t.isConnected) {
          var o = V.extractText(t), u = new so(), s = function(c, l, f) {
            return Vn(c, l, "word", f);
          }(o, a, e.spellcheckMarkerNode);
          u.addMatches(s), s = e.whitespace.findMatches(o), u.addMatches(s), e.safeHighlightMatches(t, u.matches);
        }
      });
    } }, { key: "safeHighlightMatches", value: function(t, e) {
      var r = this, i = this.editable.getSelection(t);
      i ? i.retainVisibleSelection(function() {
        r.highlightMatches(t, e);
      }) : this.highlightMatches(t, e), this.editable.dispatcher && this.editable.dispatcher.notify("spellcheckUpdated", t);
    } }, { key: "highlightMatches", value: function(t, e) {
      this.removeHighlights(t), e && e.length > 0 && V.highlightMatches(t, e);
    } }, { key: "removeHighlights", value: function(t) {
      t = We(t, this.win.document);
      var e, r = Or(U('[data-highlight="spellcheck"], [data-highlight="whitespace"]', t));
      try {
        for (r.s(); !(e = r.n()).done; )
          P(e.value);
      } catch (i) {
        r.e(i);
      } finally {
        r.f();
      }
    } }, { key: "removeHighlightsAtCursor", value: function(t) {
      t = We(t, this.win.document);
      var e = this.editable.getSelection(t);
      if (e && e.isCursor) {
        var r, i = e.range.startContainer;
        i.nodeType === y && (i = i.parentNode);
        do {
          if (i === t)
            return;
          var a = i.getAttribute("data-highlight");
          if (a === "spellcheck" || a === "whitespace") {
            r = i.getAttribute("data-word-id");
            break;
          }
        } while (i = i.parentNode);
        r && e.retainVisibleSelection(function() {
          var o, u = Or(U('[data-word-id="'.concat(r, '"]'), t));
          try {
            for (u.s(); !(o = u.n()).done; )
              P(o.value);
          } catch (s) {
            u.e(s);
          } finally {
            u.f();
          }
        });
      }
    } }]), n;
  }();
  function gt() {
    if (d.log !== !1 && k.g.console) {
      var n = arguments.length === 1 ? arguments[0] : Array.from(arguments);
      return arguments.length !== 1 && n[n.length - 1] === "trace" && (n.pop(), console.trace && console.trace()), console.log(n);
    }
  }
  function Ie(n) {
    return Tt(new it(n, "getNextTextNode"));
  }
  function Rr(n) {
    for (var t, e = n.textNodes, r = n.absOffset, i = 0, a = 0, o = 0; o < e.length; o++) {
      var u = e[o];
      if (r <= i + u.textContent.length) {
        t = u, a = r - i;
        break;
      }
      i += u.textContent.length;
    }
    return { node: t, relativeOffset: a };
  }
  function jr(n) {
    n.rightLimit = n.currentOffset, n.currentOffset = Math.floor((n.currentOffset + n.leftLimit) / 2);
  }
  function Br(n) {
    n.leftLimit = n.currentOffset, n.currentOffset = Math.ceil((n.currentOffset + n.rightLimit) / 2);
  }
  function Lr(n) {
    var t = Rr({ textNodes: n.textNodes, absOffset: n.offset }), e = t.node, r = t.relativeOffset, i = e.ownerDocument.createRange();
    return i.setStart(e, r), i.collapse(!0), i;
  }
  function vt(n, t) {
    var e = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (!e) {
      if (Array.isArray(n) || (e = function(s, c) {
        if (s) {
          if (typeof s == "string")
            return Mr(s, c);
          var l = Object.prototype.toString.call(s).slice(8, -1);
          return l === "Object" && s.constructor && (l = s.constructor.name), l === "Map" || l === "Set" ? Array.from(s) : l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l) ? Mr(s, c) : void 0;
        }
      }(n)) || t && n && typeof n.length == "number") {
        e && (n = e);
        var r = 0, i = function() {
        };
        return { s: i, n: function() {
          return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
        }, e: function(s) {
          throw s;
        }, f: i };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var a, o = !0, u = !1;
    return { s: function() {
      e = e.call(n);
    }, n: function() {
      var s = e.next();
      return o = s.done, s;
    }, e: function(s) {
      u = !0, a = s;
    }, f: function() {
      try {
        o || e.return == null || e.return();
      } finally {
        if (u)
          throw a;
      }
    } };
  }
  function Mr(n, t) {
    (t == null || t > n.length) && (t = n.length);
    for (var e = 0, r = new Array(t); e < t; e++)
      r[e] = n[e];
    return r;
  }
  var Ft = function() {
    function n(t) {
      E(this, n);
      var e, r = { window, defaultBehavior: !0, mouseMoveSelectionChanges: !1, browserSpellcheck: !0 };
      this.config = Object.assign(r, t), this.win = this.config.window, this.editableSelector = ".".concat(d.editableClass), this.dispatcher = new Si(this), this.config.defaultBehavior === !0 && this.dispatcher.on((e = function(i) {
        var a = i.win.document;
        return { focus: function(o) {
          Ge(o) && o.appendChild(a.createTextNode("\uFEFF"));
        }, blur: function(o) {
          a.activeElement !== o && ln(o);
        }, selection: function(o, u) {
          gt(u ? "Default selection behavior" : "Default selection empty behavior");
        }, cursor: function(o, u) {
          gt(u ? "Default cursor behavior" : "Default cursor empty behavior");
        }, newline: function(o, u) {
          if (u.isAtTextEnd()) {
            var s, c = a.createElement("br");
            u.insertBefore(c), ((s = c.nextSibling) === null || s === void 0 ? void 0 : s.nodeType) === y && c.nextSibling.textContent[0] === "\uFEFF" || u.insertAfter(a.createTextNode("\uFEFF"));
          } else
            u.insertBefore(a.createElement("br"));
          u.setVisibleSelection();
        }, insert: function(o, u, s) {
          var c = o.parentNode, l = o.cloneNode(!1);
          switch (l.id && l.removeAttribute("id"), u) {
            case "before":
              c.insertBefore(l, o), o.focus();
              break;
            case "after":
              c.insertBefore(l, o.nextSibling), l.focus();
          }
        }, split: function(o, u, s, c) {
          var l = o.cloneNode(!1);
          for (l.appendChild(u), o.parentNode.insertBefore(l, o); o.firstChild; )
            o.removeChild(o.firstChild);
          o.appendChild(s), at(l), at(o), o.focus();
        }, merge: function(o, u, s) {
          var c, l;
          switch (u) {
            case "before":
              c = Sn(o), l = o;
              break;
            case "after":
              c = o, l = wn(o);
          }
          c && l && (s = c.childNodes.length > 0 ? i.appendTo(c, l.innerHTML) : i.prependTo(c, l.innerHTML), l.remove(), s.save(), at(c), s.restore(), s.setVisibleSelection());
        }, empty: function(o) {
          gt("Default empty behavior");
        }, switch: function(o, u, s) {
          switch (u) {
            case "before":
              var c = Sn(o);
              c && (s.moveAtTextEnd(c), s.setVisibleSelection());
              break;
            case "after":
              var l = wn(o);
              l && (s.moveAtBeginning(l), s.setVisibleSelection());
          }
        }, move: function(o, u, s) {
          gt("Default move behavior");
        }, paste: function(o, u, s) {
          if (u.length !== 0) {
            if (s.insertBefore(u.shift()), u.length === 0)
              return s.setVisibleSelection();
            var c = o.parentNode, l = o;
            u.forEach(function(f) {
              var h = o.cloneNode(!1);
              h.id && h.removeAttribute("id");
              var g = X(f);
              h.appendChild(g), c.insertBefore(h, l.nextSibling), l = h;
            }), i.createCursorAtEnd(l).setVisibleSelection();
          }
        }, clipboard: function(o, u, s) {
          gt("Default clipboard behavior");
        }, toggleBold: function(o) {
          o.toggleBold();
        }, toggleEmphasis: function(o) {
          o.toggleEmphasis();
        } };
      }(this), { focus: function(i) {
        e.focus(i);
      }, blur: function(i) {
        e.blur(i);
      }, flow: function(i, a) {
        e.flow(i, a);
      }, selection: function(i, a) {
        e.selection(i, a);
      }, cursor: function(i, a) {
        e.cursor(i, a);
      }, newline: function(i, a) {
        e.newline(i, a);
      }, split: function(i, a, o, u) {
        e.split(i, a, o, u);
      }, insert: function(i, a, o) {
        e.insert(i, a, o);
      }, merge: function(i, a, o) {
        e.merge(i, a, o);
      }, empty: function(i) {
        e.empty(i);
      }, switch: function(i, a, o) {
        e.switch(i, a, o);
      }, move: function(i, a, o) {
        e.move(i, a, o);
      }, clipboard: function(i, a, o) {
        e.clipboard(i, a, o);
      }, paste: function(i, a, o) {
        e.paste(i, a, o);
      }, toggleBold: function(i) {
        e.toggleBold(i);
      }, toggleEmphasis: function(i) {
        e.toggleEmphasis(i);
      } }));
    }
    return O(n, [{ key: "add", value: function(t, e) {
      return this.enable(t, e), this;
    } }, { key: "remove", value: function(t) {
      var e = U(t, this.win.document);
      this.disable(e);
      var r, i = vt(e);
      try {
        for (i.s(); !(r = i.n()).done; )
          r.value.classList.remove(d.editableDisabledClass);
      } catch (a) {
        i.e(a);
      } finally {
        i.f();
      }
      return this;
    } }, { key: "disable", value: function(t) {
      var e, r, i = vt(U(t || ".".concat(d.editableClass), this.win.document));
      try {
        for (i.s(); !(e = i.n()).done; )
          (r = e.value).removeAttribute("contenteditable"), r.removeAttribute("spellcheck"), r.removeAttribute("data-plaintext"), function(a, o) {
            if (a.hasAttribute("data-editable")) {
              var u = a.getAttribute("data-editable");
              ri[u] = void 0;
            }
          }(r), r.classList.remove(d.editableClass), r.classList.add(d.editableDisabledClass);
      } catch (a) {
        i.e(a);
      } finally {
        i.f();
      }
      return this;
    } }, { key: "enable", value: function(t, e) {
      var r, i = e ?? {}, a = i.normalize, o = a === void 0 ? typeof e == "boolean" && e : a, u = i.plainText, s = u !== void 0 && u, c = this.config.browserSpellcheck, l = vt(U(t || ".".concat(d.editableDisabledClass), this.win.document));
      try {
        for (l.s(); !(r = l.n()).done; ) {
          var f = r.value;
          ii(f, { normalize: o, plainText: s, shouldSpellcheck: c }), this.dispatcher.notify("init", f);
        }
      } catch (h) {
        l.e(h);
      } finally {
        l.f();
      }
      return this;
    } }, { key: "suspend", value: function(t) {
      var e, r = vt(U(t || ".".concat(d.editableClass), this.win.document));
      try {
        for (r.s(); !(e = r.n()).done; )
          e.value.removeAttribute("contenteditable");
      } catch (i) {
        r.e(i);
      } finally {
        r.f();
      }
      return this.dispatcher.suspend(), this;
    } }, { key: "continue", value: function(t) {
      var e, r = vt(U(t || ".".concat(d.editableClass), this.win.document));
      try {
        for (r.s(); !(e = r.n()).done; )
          e.value.setAttribute("contenteditable", !0);
      } catch (i) {
        r.e(i);
      } finally {
        r.f();
      }
      return this.dispatcher.continue(), this;
    } }, { key: "createCursor", value: function(t) {
      var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "beginning", r = B.findHost(t, this.editableSelector);
      if (r) {
        var i = F();
        return e === "beginning" || e === "end" ? (i.selectNodeContents(t), i.collapse(e === "beginning")) : t !== r ? e === "before" ? (i.setStartBefore(t), i.setEndBefore(t)) : e === "after" && (i.setStartAfter(t), i.setEndAfter(t)) : Q("EditableJS: cannot create cursor outside of an editable block."), new B(r, i);
      }
    } }, { key: "createCursorAtCharacterOffset", value: function(t) {
      var e = t.element, r = t.offset, i = Rr({ textNodes: Ie(e), absOffset: r }), a = i.node, o = i.relativeOffset, u = F();
      u.setStart(a, o), u.collapse(!0);
      var s = B.findHost(e, this.editableSelector), c = new B(s, u);
      return c.setVisibleSelection(), c;
    } }, { key: "createCursorAtBeginning", value: function(t) {
      return this.createCursor(t, "beginning");
    } }, { key: "createCursorAtEnd", value: function(t) {
      return this.createCursor(t, "end");
    } }, { key: "createCursorBefore", value: function(t) {
      return this.createCursor(t, "before");
    } }, { key: "createCursorAfter", value: function(t) {
      return this.createCursor(t, "after");
    } }, { key: "getContent", value: function(t) {
      return ie(t);
    } }, { key: "appendTo", value: function(t, e) {
      var r = At(t, this.win.document), i = this.createCursor(r, "end");
      return i.insertAfter(typeof e == "string" ? X(e) : e), i;
    } }, { key: "prependTo", value: function(t, e) {
      var r = At(t, this.win.document), i = this.createCursor(r, "beginning");
      return i.insertBefore(typeof e == "string" ? X(e) : e), i;
    } }, { key: "getSelection", value: function(t) {
      var e = this.dispatcher.selectionWatcher.getFreshSelection();
      if (!t || !e)
        return e;
      var r = e.range;
      return t != null && t.isConnected && function(i, a) {
        var o = document.createRange();
        o.selectNodeContents(i);
        var u = a.compareBoundaryPoints(Range.START_TO_START, o), s = a.compareBoundaryPoints(Range.END_TO_END, o);
        return u >= 0 && s <= 0;
      }(t, r) ? e : void 0;
    } }, { key: "setupHighlighting", value: function(t) {
      return this.highlighting = new co(this, t), this;
    } }, { key: "setupSpellcheck", value: function(t) {
      var e, r = this;
      t.markerNode && (e = t.markerNode.outerHTML), this.setupHighlighting({ throttle: t.throttle, spellcheck: { marker: e, spellcheckService: t.spellcheckService } }), this.spellcheck = { checkSpelling: function(i) {
        r.highlighting.highlight(i);
      } };
    } }, { key: "highlight", value: function(t) {
      var e = t.editableHost, r = t.text, i = t.highlightId, a = t.textRange, o = t.raiseEvents, u = t.type, s = u === void 0 ? "comment" : u;
      return a ? typeof a.start != "number" || typeof a.end != "number" ? (Q("Error in Editable.highlight: You passed a textRange object with invalid keys. Expected shape: { start: Number, end: Number }"), -1) : a.start === a.end ? (Q("Error in Editable.highlight: You passed a textRange object with equal start and end offsets, which is considered a cursor and therefore unfit to create a highlight."), -1) : I.highlightRange(e, r, i, a.start, a.end, o ? this.dispatcher : void 0, s) : I.highlightText(e, r, i, s);
    } }, { key: "getHighlightPositions", value: function(t) {
      var e = t.editableHost, r = t.type;
      return I.extractHighlightedRanges(e, r);
    } }, { key: "removeHighlight", value: function(t) {
      var e = t.editableHost, r = t.highlightId, i = t.raiseEvents;
      I.removeHighlight(e, r, i ? this.dispatcher : void 0);
    } }, { key: "decorateHighlight", value: function(t) {
      var e = t.editableHost, r = t.highlightId, i = t.addCssClass, a = t.removeCssClass;
      I.updateHighlight(e, r, i, a);
    } }, { key: "on", value: function(t, e) {
      return this.dispatcher.on(t, e), this;
    } }, { key: "off", value: function() {
      for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
        e[r] = arguments[r];
      return this.dispatcher.off.apply(this.dispatcher, e), this;
    } }, { key: "unload", value: function() {
      return this.dispatcher.unload(), this;
    } }, { key: "findClosestCursorOffset", value: function(t) {
      var e = t.element, r = t.origCoordinates, i = t.requiredOnFirstLine, a = i !== void 0 && i, o = t.requiredOnLastLine;
      return function(u) {
        var s = u.host, c = u.requiredOnFirstLine, l = u.requiredOnLastLine, f = u.positionX, h = s.ownerDocument.createRange();
        h.selectNodeContents(s);
        var g = h.getBoundingClientRect(), v = Ie(s).reduce(function(pt, Ht) {
          return pt + Ht.textContent.length;
        }, 0), b = Ie(s);
        if (v === 0)
          return { wasFound: !1 };
        for (var T, p = { currentOffset: Math.floor(v / 2), leftLimit: 0, rightLimit: v }, C = p.currentOffset, et = 20; p.leftLimit < p.rightLimit && et > 0; ) {
          et = et -= 1, C = p.currentOffset;
          var S = Lr({ textNodes: b, offset: p.currentOffset }).getBoundingClientRect();
          T = Math.abs(S.left - f), c && g.top !== S.top ? jr(p) : l && g.bottom !== S.bottom ? Br(p) : f < S.left ? jr(p) : Br(p);
        }
        var $ = Lr({ textNodes: b, offset: p.currentOffset }).getBoundingClientRect(), nt = Math.abs($.left - f);
        return nt < T && (T = nt, C = p.currentOffset), { distance: T, offset: C, wasFound: !0 };
      }({ host: e, requiredOnFirstLine: a, requiredOnLastLine: o !== void 0 && o, positionX: this.dispatcher.switchContext ? this.dispatcher.switchContext.positionX : r.left });
    } }], [{ key: "getGlobalConfig", value: function() {
      return d;
    } }, { key: "globalConfig", value: function(t) {
      Object.assign(d, t), Mn(d);
    } }]), n;
  }();
  return Ft.parser = q, Ft.content = D, ["focus", "blur", "flow", "selection", "cursor", "newline", "insert", "split", "merge", "empty", "change", "switch", "move", "clipboard", "paste", "spellcheckUpdated", "selectToBoundary"].forEach(function(n) {
    Ft.prototype[n] = function(t) {
      return this.on(n, t);
    };
  }), W.Editable;
})(), j.exports = Fr();
const Eo = yo(Fe.exports), mo = fo`
  :host {
    border: var(--exo-spacing-3x-small) solid transparent;
    display: block;
  }
  :host(:focus) {
    border: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-action-hover);
  }
`;
var bo = Object.defineProperty, ko = Object.getOwnPropertyDescriptor, mt = (k, W, q, D) => {
  for (var E, A = D > 1 ? void 0 : D ? ko(W, q) : W, rt = k.length - 1; rt >= 0; rt--)
    (E = k[rt]) && (A = (D ? E(W, q, A) : E(A)) || A);
  return D && A && bo(W, q, A), A;
}, Co = ((k) => (k.MENTION = "mention", k.AUTOCOMPLETE = "autocomplete", k))(Co || {});
class K extends go {
  constructor() {
    super(...arguments), this.label = "", this.tabIndex = -1, this.value = "", this.context = [], this.type = "mention";
  }
  render() {
    return vo`<div class="container"><slot></slot></div>`;
  }
}
K.styles = mo, mt([yt()], K.prototype, "label", 2), mt([yt({ reflect: !0, attribute: "tabIndex" })], K.prototype, "tabIndex", 2), mt([yt()], K.prototype, "value", 2), mt([yt({ type: Object })], K.prototype, "context", 2), mt([yt()], K.prototype, "type", 2);
const To = po("ex-rich-input-suggestion", K);
export {
  Eo as E,
  Co as R,
  K as a,
  To as r
};
